{
  "$id": "urn:dm:schemas:componentsDefinitionsMap.json",
  "core.components.Image": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      "Image",
      ""
    ],
    "styles": {},
    "nickname": "image"
  },
  "core.components.MenuButton": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      "Link",
      "Page",
      "",
      "AppPage",
      "Text",
      "BasicMenuItem"
    ],
    "styles": {},
    "nickname": "componentLabelMenuButton"
  },
  "mobile.core.components.Page": {
    "type": "Page",
    "aliases": [
      "core.components.Page"
    ],
    "skins": [
      "wysiwyg.viewer.skins.page.TransparentPageSkin",
      "wysiwyg.viewer.skins.page.SloopyPageSkin",
      "wysiwyg.viewer.skins.page.BasicPageSkin",
      "wysiwyg.viewer.skins.page.ThreeDeePageSkin",
      "wysiwyg.viewer.skins.page.InnerShadowPageSkin",
      "wysiwyg.viewer.skins.page.LiftedBottomPageSkin",
      "wysiwyg.viewer.skins.page.LiftedTopPageSkin",
      "wysiwyg.viewer.skins.page.BorderPageSkin",
      "wysiwyg.viewer.skins.page.LiftedShadowPageSkin",
      "wysiwyg.viewer.skins.page.ShinyIPageSkin",
      "wysiwyg.viewer.skins.page.NoMarginPageSkin"
    ],
    "dataTypes": [
      "Page"
    ],
    "styles": {
      "p1": "wysiwyg.viewer.skins.page.TransparentPageSkin",
      "p2": "wysiwyg.viewer.skins.page.SloopyPageSkin",
      "p3": "wysiwyg.viewer.skins.page.BasicPageSkin",
      "p4": "wysiwyg.viewer.skins.page.FullWidthPageSkin"
    },
    "nickname": "page",
    "designDataTypes": [
      "",
      "MediaContainerDesignData"
    ],
    "propertyTypes": [
      "",
      "PageProperties"
    ]
  },
  "mobile.core.components.MasterPage": {
    "type": "Document",
    "skins": [],
    "dataTypes": [
      "Document"
    ],
    "styles": {},
    "nickname": "masterPage"
  },
  "wixapps.integration.components.AppPage": {
    "type": "Page",
    "skins": [
      "wysiwyg.viewer.skins.page.TransparentPageSkin",
      "wysiwyg.viewer.skins.page.SloopyPageSkin",
      "wysiwyg.viewer.skins.page.BasicPageSkin",
      "wysiwyg.viewer.skins.page.ThreeDeePageSkin",
      "wysiwyg.viewer.skins.page.InnerShadowPageSkin",
      "wysiwyg.viewer.skins.page.LiftedBottomPageSkin",
      "wysiwyg.viewer.skins.page.LiftedTopPageSkin",
      "wysiwyg.viewer.skins.page.BorderPageSkin",
      "wysiwyg.viewer.skins.page.LiftedShadowPageSkin",
      "wysiwyg.viewer.skins.page.ShinyIPageSkin",
      "wysiwyg.viewer.skins.page.NoMarginPageSkin"
    ],
    "dataTypes": [
      "AppPage"
    ],
    "styles": {
      "p1": "wysiwyg.viewer.skins.page.TransparentPageSkin",
      "p2": "wysiwyg.viewer.skins.page.SloopyPageSkin",
      "p3": "wysiwyg.viewer.skins.page.BasicPageSkin"
    },
    "nickname": "page",
    "propertyTypes": [
      "",
      "PageProperties"
    ]
  },
  "wixapps.integration.components.AppPart": {
    "type": "Component",
    "skins": [
      "wysiwyg.viewer.skins.AppPartSkin"
    ],
    "dataTypes": [
      "AppPart"
    ],
    "styles": {
      "blog_4de5abc5-6da2-4f97-acc3-94bb74285072_1": "wysiwyg.viewer.skins.AppPartSkin",
      "blog_f72fe377-8abc-40f2-8656-89cfe00f3a22_1": "wysiwyg.viewer.skins.AppPartSkin",
      "blog_c7f57b50-8940-4ff1-83c6-6756d6f0a1f4_1": "wysiwyg.viewer.skins.AppPartSkin",
      "blog_56ab6fa4-95ac-4391-9337-6702b8a77011_1": "wysiwyg.viewer.skins.AppPartSkin",
      "blog_e000b4bf-9ff1-4e66-a0d3-d4b365ba3af5_1": "wysiwyg.viewer.skins.AppPartSkin",
      "blog_31c0cede-09db-4ec7-b760-d375d62101e6_1": "wysiwyg.viewer.skins.AppPartSkin",
      "blog_33a9f5e0-b083-4ccc-b55d-3ca5d241a6eb_1": "wysiwyg.viewer.skins.AppPartSkin",
      "blog_1b8c501f-ccc2-47e7-952a-47e264752614_1": "wysiwyg.viewer.skins.AppPartSkin",
      "blog_4656a63c-b316-4315-ab16-e2003f5935ca_1": "wysiwyg.viewer.skins.AppPartSkin"
    },
    "nickname": "blog",
    "propertyTypes": [
      "AppPartProperties"
    ]
  },
  "wixapps.integration.components.AppPart2": {
    "type": "Component",
    "skins": [
      "wysiwyg.viewer.skins.AppPartSkin"
    ],
    "dataTypes": [
      "AppBuilderComponent"
    ],
    "styles": {
      "app1": "wysiwyg.viewer.skins.AppPartSkin"
    },
    "nickname": "list"
  },
  "wysiwyg.viewer.components.inputs.TextInput": {
    "type": "Component",
    "skins": [
      "wysiwyg.viewer.skins.appinputs.AppsTextInputSkin"
    ],
    "dataTypes": [
      "TextInput"
    ],
    "styles": {
      "wa_ti1": "wysiwyg.viewer.skins.appinputs.AppsTextInputSkin"
    },
    "nickname": "input",
    "propertyTypes": [
      "TextInputProperties"
    ],
    "externalizable": true
  },
  "wysiwyg.viewer.components.menus.DropDownMenu": {
    "type": "Component",
    "externalizable": true,
    "responsiveSkins": [],
    "skins": [
      "wysiwyg.common.components.dropdownmenu.viewer.skins.TextOnlyMenuButtonSkin",
      "wysiwyg.common.components.dropdownmenu.viewer.skins.TextOnlyMenuButtonBgFixSkin",
      "wysiwyg.common.components.dropdownmenu.viewer.skins.TextSeparatorsMenuButtonSkin",
      "wysiwyg.common.components.dropdownmenu.viewer.skins.SolidColorMenuButtonSkin",
      "wysiwyg.common.components.dropdownmenu.viewer.skins.ShinyMenuIButtonSkin",
      "wysiwyg.common.components.dropdownmenu.viewer.skins.ShinyMenuIIButtonSkin",
      "wysiwyg.common.components.dropdownmenu.viewer.skins.OverlineMenuButtonSkin",
      "wysiwyg.common.components.dropdownmenu.viewer.skins.SeparateBasicMenuButtonSkin",
      "wysiwyg.common.components.dropdownmenu.viewer.skins.SeparateShinyIMenuButtonSkin",
      "wysiwyg.common.components.dropdownmenu.viewer.skins.SeparateShinyIIMenuButtonSkin",
      "wysiwyg.common.components.dropdownmenu.viewer.skins.LinesMenuButtonSkin",
      "wysiwyg.common.components.dropdownmenu.viewer.skins.SeparateLinesMenuButtonSkin",
      "wysiwyg.common.components.dropdownmenu.viewer.skins.PointerMenuButtonSkin",
      "wysiwyg.common.components.dropdownmenu.viewer.skins.RibbonsMenuButtonSkin",
      "wysiwyg.common.components.dropdownmenu.viewer.skins.VerticalRibbonsMenuButtonSkin",
      "wysiwyg.common.components.dropdownmenu.viewer.skins.IndentedMenuButtonSkin",
      "wysiwyg.common.components.dropdownmenu.viewer.skins.SeparateIndentedMenuButtonSkin",
      "wysiwyg.common.components.dropdownmenu.viewer.skins.SloppyBorderMenuButtonSkin",
      "wysiwyg.common.components.dropdownmenu.viewer.skins.OverlineMenuButtonHorizontalMenuAdaptationSkin"
    ],
    "dataTypes": [
      "CustomMenuDataRef"
    ],
    "styles": {
      "ddm1": "wysiwyg.common.components.dropdownmenu.viewer.skins.TextOnlyMenuButtonSkin",
      "ddm2": "wysiwyg.common.components.dropdownmenu.viewer.skins.SolidColorMenuButtonSkin",
      "ddm3": "wysiwyg.common.components.dropdownmenu.viewer.skins.ShinyMenuIButtonSkin"
    },
    "nickname": "horizontalMenu",
    "propertyTypes": [
      "HorizontalMenuProperties"
    ]
  },
  "wixapps.integration.components.Icon": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      "Icon"
    ],
    "styles": {
      "skin": "wixapps.integration.skins.IconSkin"
    },
    "nickname": "icon"
  },
  "wixapps.integration.components.ImageButton": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      "ImageButton"
    ],
    "styles": {
      "ImageButton_1": "wysiwyg.common.components.imagebutton.viewer.skins.ImageButtonSkin"
    },
    "nickname": "iconButton",
    "propertyTypes": [
      "ImageButtonProperties"
    ]
  },
  "wysiwyg.common.components.rssbutton.viewer.RSSButton": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      "RssButton"
    ],
    "styles": {
      "RSSButton_1": "wysiwyg.common.components.rssbutton.viewer.skins.RSSButtonSkin"
    },
    "nickname": "rssButton",
    "propertyTypes": [
      "RssButtonProperties"
    ],
    "externalizable": true
  },
  "wysiwyg.common.components.anchor.viewer.Anchor": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.common.components.anchor.viewer.skins.AnchorSkin",
      "AutoWidthAnchorSkin"
    ],
    "dataTypes": [
      "Anchor"
    ],
    "styles": {
      "Anchor_1": "wysiwyg.common.components.anchor.viewer.skins.AnchorSkin",
      "Anchor_2": "AutoWidthAnchorSkin"
    },
    "nickname": "anchor"
  },
  "wysiwyg.common.components.verticalanchorsmenu.viewer.VerticalAnchorsMenu": {
    "type": "Component",
    "skins": [
      "wysiwyg.common.components.verticalanchorsmenu.viewer.skins.VerticalAnchorsMenuSymbolSkin",
      "wysiwyg.common.components.verticalanchorsmenu.viewer.skins.VerticalAnchorsMenuTextSkin",
      "wysiwyg.common.components.verticalanchorsmenu.viewer.skins.VerticalAnchorsMenuSymbolWithTextSkin",
      "wysiwyg.common.components.verticalanchorsmenu.viewer.skins.VerticalAnchorsMenuSymbolWithHiddenTextSkin",
      "wysiwyg.common.components.verticalanchorsmenu.viewer.skins.VerticalAnchorsMenuLinkedNoTextSkin"
    ],
    "dataTypes": [
      "VerticalAnchorsMenu"
    ],
    "styles": {
      "VerticalAnchors_1": "wysiwyg.common.components.verticalanchorsmenu.viewer.skins.VerticalAnchorsMenuSymbolWithHiddenTextSkin",
      "VerticalAnchors_2": "wysiwyg.common.components.verticalanchorsmenu.viewer.skins.VerticalAnchorsMenuSymbolWithTextSkin",
      "VerticalAnchors_3": "wysiwyg.common.components.verticalanchorsmenu.viewer.skins.VerticalAnchorsMenuSymbolSkin",
      "VerticalAnchors_4": "wysiwyg.common.components.verticalanchorsmenu.viewer.skins.VerticalAnchorsMenuTextSkin",
      "VerticalAnchors_5": "wysiwyg.common.components.verticalanchorsmenu.viewer.skins.VerticalAnchorsMenuLinkedNoTextSkin"
    },
    "nickname": "anchorMenu",
    "propertyTypes": [
      "VerticalAnchorsMenuProperties"
    ],
    "externalizable": true
  },
  "wysiwyg.common.components.facebooklikebox.viewer.FacebookLikeBox": {
    "type": "Component",
    "skins": [
      "wysiwyg.common.components.facebooklikebox.viewer.skins.FacebookLikeBoxSkin"
    ],
    "dataTypes": [
      "FacebookLikeBox"
    ],
    "styles": {
      "FacebookLikeBox_1": "wysiwyg.common.components.facebooklikebox.viewer.skins.FacebookLikeBoxSkin"
    },
    "nickname": "facebookPageLike",
    "propertyTypes": [
      "FacebookLikeBoxProperties"
    ],
    "externalizable": true
  },
  "wysiwyg.common.components.imagebutton.viewer.ImageButton": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.common.components.imagebutton.viewer.skins.ImageButtonSkin"
    ],
    "dataTypes": [
      "ImageButton"
    ],
    "styles": {
      "ImageButton_1": "wysiwyg.common.components.imagebutton.viewer.skins.ImageButtonSkin"
    },
    "nickname": "iconButton",
    "propertyTypes": [
      "ImageButtonProperties"
    ]
  },
  "wysiwyg.common.components.inputs.OptionsListInput": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      "SelectableList"
    ],
    "styles": {},
    "nickname": "optionsListInput"
  },
  "wysiwyg.common.components.inputs.SelectOptionsList": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      "SelectableList"
    ],
    "styles": {},
    "nickname": "selectOptionsList"
  },
  "wysiwyg.common.components.pinitpinwidget.viewer.PinItPinWidget": {
    "type": "Component",
    "skins": [
      "wysiwyg.common.components.pinitpinwidget.viewer.skins.PinItPinWidgetSkin"
    ],
    "dataTypes": [
      "PinItPinWidget"
    ],
    "styles": {
      "PinItPinWidget_1": "wysiwyg.common.components.pinitpinwidget.viewer.skins.PinItPinWidgetSkin"
    },
    "nickname": "shareFromPinterest",
    "externalizable": true
  },
  "wysiwyg.common.components.pinterestpinit.viewer.PinterestPinIt": {
    "type": "Component",
    "skins": [
      "wysiwyg.common.components.pinterestpinit.viewer.skins.PinterestPinItSkin"
    ],
    "dataTypes": [
      "PinterestPinIt"
    ],
    "styles": {
      "PinterestPinIt_1": "wysiwyg.common.components.pinterestpinit.viewer.skins.PinterestPinItSkin"
    },
    "nickname": "pinToPinterest",
    "propertyTypes": [
      "PinterestPinItProperties"
    ],
    "externalizable": true
  },
  "wysiwyg.common.components.singleaudioplayer.viewer.SingleAudioPlayer": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.common.components.singleaudioplayer.viewer.skins.SingleAudioPlayerSkin",
      "wysiwyg.common.components.singleaudioplayer.viewer.skins.EPlayerRoundPlay",
      "wysiwyg.common.components.singleaudioplayer.viewer.skins.EPlayerFramedPlay",
      "wysiwyg.common.components.singleaudioplayer.viewer.skins.EPlayerLargePlay"
    ],
    "dataTypes": [
      "SingleAudioPlayer"
    ],
    "styles": {
      "SingleAudioPlayer_1": "wysiwyg.common.components.singleaudioplayer.viewer.skins.SingleAudioPlayerSkin"
    },
    "nickname": "trackPlayer",
    "propertyTypes": [
      "SingleAudioPlayerProperties"
    ]
  },
  "wysiwyg.common.components.skypecallbutton.viewer.SkypeCallButton": {
    "type": "Component",
    "skins": [
      "wysiwyg.common.components.skypecallbutton.viewer.skins.SkypeCallButtonSkin"
    ],
    "dataTypes": [
      "SkypeCallButton"
    ],
    "styles": {
      "SkypeCallButton_1": "wysiwyg.common.components.skypecallbutton.viewer.skins.SkypeCallButtonSkin"
    },
    "nickname": "skypeCall",
    "propertyTypes": [
      "SkypeCallButtonProperties"
    ],
    "externalizable": true
  },
  "wysiwyg.common.components.spotifyfollow.viewer.SpotifyFollow": {
    "type": "Component",
    "skins": [
      "wysiwyg.common.components.spotifyfollow.viewer.skins.SpotifyFollowSkin"
    ],
    "dataTypes": [
      "SpotifyFollow"
    ],
    "styles": {
      "SpotifyFollow_1": "wysiwyg.common.components.spotifyfollow.viewer.skins.SpotifyFollowSkin"
    },
    "nickname": "spotifyFollow",
    "propertyTypes": [
      "SpotifyFollowProperties"
    ],
    "externalizable": true
  },
  "wysiwyg.common.components.spotifyplayer.viewer.SpotifyPlayer": {
    "type": "Component",
    "skins": [
      "wysiwyg.common.components.spotifyplayer.viewer.skins.SpotifyPlayerSkin"
    ],
    "dataTypes": [
      "SpotifyPlayer"
    ],
    "styles": {
      "SpotifyPlayer_1": "wysiwyg.common.components.spotifyplayer.viewer.skins.SpotifyPlayerSkin"
    },
    "nickname": "spotifyPlayer",
    "propertyTypes": [
      "SpotifyPlayerProperties"
    ],
    "externalizable": true
  },
  "wysiwyg.common.components.subscribeform.viewer.SubscribeForm": {
    "type": "Component",
    "skins": [
      "wysiwyg.common.components.subscribeform.viewer.skins.SubscribeFormPlaceholderSkin",
      "wysiwyg.common.components.subscribeform.viewer.skins.SubscribeFormBoxLayoutEnvelope",
      "wysiwyg.common.components.subscribeform.viewer.skins.SubscribeFormBoxLayoutFlat",
      "wysiwyg.common.components.subscribeform.viewer.skins.SubscribeFormLineLayoutFlat",
      "wysiwyg.common.components.subscribeform.viewer.skins.SubscribeFormLineLayoutTransparentWithIcon",
      "wysiwyg.common.components.subscribeform.viewer.skins.SubscribeFormBoxLayoutShiny"
    ],
    "dataTypes": [
      "SubscribeForm"
    ],
    "styles": {
      "SubscribeForm_1": "wysiwyg.common.components.subscribeform.viewer.skins.SubscribeFormBoxLayoutFlat"
    },
    "nickname": "subscribeForm",
    "propertyTypes": [
      "SubscribeFormProperties"
    ]
  },
  "wysiwyg.common.components.verticalmenu.viewer.VerticalMenu": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.common.components.verticalmenu.viewer.skins.VerticalMenuSolidColorSkin",
      "wysiwyg.common.components.verticalmenu.viewer.skins.VerticalMenuSeparatedButtonFixedWidthSkin",
      "wysiwyg.common.components.verticalmenu.viewer.skins.VerticalMenuTextSkin",
      "wysiwyg.common.components.verticalmenu.viewer.skins.VerticalMenuSeparatedButtonSkin",
      "wysiwyg.common.components.verticalmenu.viewer.skins.VerticalMenuTextWithSeparatorsSkin"
    ],
    "dataTypes": [
      "CustomMenuDataRef"
    ],
    "styles": {
      "VerticalMenu_1": "wysiwyg.common.components.verticalmenu.viewer.skins.VerticalMenuSolidColorSkin"
    },
    "nickname": "verticalMenu",
    "propertyTypes": [
      "VerticalMenuProperties"
    ]
  },
  "wysiwyg.common.components.youtubesubscribebutton.viewer.YouTubeSubscribeButton": {
    "type": "Component",
    "skins": [
      "wysiwyg.common.components.youtubesubscribebutton.viewer.skins.YouTubeSubscribeButtonSkin"
    ],
    "dataTypes": [
      "YouTubeSubscribeButton"
    ],
    "styles": {
      "YouTubeSubscribeButton_1": "wysiwyg.common.components.youtubesubscribebutton.viewer.skins.YouTubeSubscribeButtonSkin"
    },
    "nickname": "youTubeSubscribe",
    "propertyTypes": [
      "YouTubeSubscribeButtonProperties"
    ],
    "externalizable": true
  },
  "wysiwyg.viewer.components.AdminLoginButton": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.button.AdminLoginButtonSkin"
    ],
    "dataTypes": [
      "LinkableButton"
    ],
    "styles": {
      "admb0": "wysiwyg.viewer.skins.button.AdminLoginButtonSkin"
    },
    "nickname": "webmasterLogin",
    "propertyTypes": [
      "ButtonProperties"
    ]
  },
  "wysiwyg.viewer.components.AudioPlayer": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.audioplayer.Audio3DPlayer",
      "wysiwyg.viewer.skins.audioplayer.ShinyPlayer",
      "wysiwyg.viewer.skins.audioplayer.SimplePlayer",
      "wysiwyg.viewer.skins.audioplayer.BoldPlayer"
    ],
    "dataTypes": [
      "AudioPlayer"
    ],
    "styles": {
      "ap1": "wysiwyg.viewer.skins.audioplayer.SimplePlayer",
      "ap2": "wysiwyg.viewer.skins.audioplayer.ShinyPlayer"
    },
    "nickname": "miniPlayer"
  },
  "wysiwyg.viewer.components.BgImageStrip": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "skins.viewer.bgimagestrip.BgImageStripSkin",
      "skins.viewer.bgimagestrip.BevelScreenSkin",
      "skins.viewer.bgimagestrip.IronScreenSkin",
      "skins.viewer.bgimagestrip.DoubleBorderScreenSkin"
    ],
    "dataTypes": [
      "Image",
      ""
    ],
    "styles": {
      "bgis1": "skins.viewer.bgimagestrip.BgImageStripSkin",
      "bgis2": "skins.viewer.bgimagestrip.BevelScreenSkin",
      "bgis3": "skins.viewer.bgimagestrip.IronScreenSkin",
      "bgis4": "skins.viewer.bgimagestrip.DoubleBorderScreenSkin"
    },
    "nickname": "strip",
    "propertyTypes": [
      "BgImageStripUnifiedProperties"
    ]
  },
  "wysiwyg.viewer.components.ClipArt": {
    "type": "Component",
    "skins": [
      "wysiwyg.viewer.skins.photo.NoSkinPhoto"
    ],
    "dataTypes": [
      "Image"
    ],
    "styles": {
      "ca1": "wysiwyg.viewer.skins.photo.NoSkinPhoto"
    },
    "nickname": "clipArt",
    "propertyTypes": [
      "WPhotoProperties"
    ]
  },
  "wysiwyg.viewer.components.ContactForm": {
    "type": "Component",
    "skins": [
      "wysiwyg.viewer.skins.contactform.DefaultContactForm",
      "wysiwyg.viewer.skins.contactform.BasicContactFormSkin",
      "wysiwyg.viewer.skins.contactform.VerticalFormLabelsLeft",
      "wysiwyg.viewer.skins.contactform.VerticalForm",
      "contactform.OverlappingButtonSkin",
      "contactform.FullWidthButtonSkin",
      "contactform.LineOnlySkin",
      "contactform.FieldAnimationSkin"
    ],
    "dataTypes": [
      "ContactForm"
    ],
    "styles": {
      "cf1": "wysiwyg.viewer.skins.contactform.DefaultContactForm",
      "cf2": "wysiwyg.viewer.skins.contactform.BasicContactFormSkin"
    },
    "nickname": "contactForm",
    "propertyTypes": [
      "ContactFormProperties"
    ]
  },
  "wysiwyg.viewer.components.DynamicContactForm": {
    "type": "Component",
    "skins": [
      "wysiwyg.viewer.skins.contactform.DefaultContactForm",
      "wysiwyg.viewer.skins.contactform.BasicContactFormSkin",
      "wysiwyg.viewer.skins.contactform.VerticalFormLabelsLeft",
      "wysiwyg.viewer.skins.contactform.VerticalForm",
      "contactform.OverlappingButtonSkin",
      "contactform.FullWidthButtonSkin",
      "contactform.LineOnlySkin",
      "contactform.FieldAnimationSkin",
      "wysiwyg.viewer.skins.contactform.HorizontalContactFormSkin"
    ],
    "dataTypes": [
      "DynamicContactForm"
    ],
    "styles": {
      "cf1": "wysiwyg.viewer.skins.contactform.DefaultContactForm",
      "cf2": "wysiwyg.viewer.skins.contactform.BasicContactFormSkin"
    },
    "nickname": "contactForm"
  },
  "wysiwyg.viewer.components.Displayer": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      "Image"
    ],
    "styles": {},
    "nickname": "displayer"
  },
  "wysiwyg.viewer.components.documentmedia.DocumentMedia": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "skins.viewer.documentmedia.DocumentMediaSkin"
    ],
    "dataTypes": [
      "Image"
    ],
    "styles": {
      "dm1": "skins.viewer.documentmedia.DocumentMediaSkin"
    },
    "nickname": "document",
    "propertyTypes": [
      "DocumentMediaProperties"
    ]
  },
  "wysiwyg.viewer.components.EbayItemsBySeller": {
    "type": "Component",
    "skins": [
      "wysiwyg.viewer.skins.EbayItemsBySellerSkin"
    ],
    "dataTypes": [
      "EbayItemsBySeller"
    ],
    "styles": {
      "eib1": "wysiwyg.viewer.skins.EbayItemsBySellerSkin"
    },
    "nickname": "eBay",
    "propertyTypes": [
      "EbayItemsBySellerProperties"
    ]
  },
  "wysiwyg.viewer.components.FacebookShare": {
    "type": "Component",
    "skins": [
      "skins.viewer.facebookshare.FacebookShareSkin"
    ],
    "dataTypes": [
      "FacebookShareButton"
    ],
    "styles": {
      "fs1": "skins.viewer.facebookshare.FacebookShareSkin"
    },
    "nickname": "facebookShare",
    "externalizable": true
  },
  "wysiwyg.viewer.components.FlashComponent": {
    "type": "Component",
    "skins": [
      "wysiwyg.viewer.skins.FlashComponentSkin"
    ],
    "dataTypes": [
      "LinkableFlashComponent"
    ],
    "styles": {
      "swf1": "wysiwyg.viewer.skins.FlashComponentSkin"
    },
    "nickname": "flash",
    "propertyTypes": [
      "FlashComponentProperties"
    ],
    "externalizable": true
  },
  "wysiwyg.viewer.components.FlickrBadgeWidget": {
    "type": "Component",
    "skins": [
      "wysiwyg.viewer.skins.FlickrBadgeWidgetSkin"
    ],
    "dataTypes": [
      "FlickrBadgeWidget"
    ],
    "styles": {
      "fk1": "wysiwyg.viewer.skins.FlickrBadgeWidgetSkin"
    },
    "nickname": "flickrGallery",
    "externalizable": true
  },
  "wysiwyg.viewer.components.GoogleMap": {
    "type": "Component",
    "skins": [
      "wysiwyg.viewer.skins.GoogleMapSkin",
      "wysiwyg.viewer.skins.map.GoogleMapDefault",
      "wysiwyg.viewer.skins.map.GoogleMapSloppy",
      "wysiwyg.viewer.skins.map.GoogleMapLiftedShadow"
    ],
    "dataTypes": [
      "GeoMap"
    ],
    "styles": {
      "gm1": "wysiwyg.viewer.skins.GoogleMapSkin"
    },
    "nickname": "googleMaps",
    "propertyTypes": [
      "GoogleMapProperties"
    ],
    "externalizable": true
  },
  "wysiwyg.viewer.components.HtmlComponent": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.HtmlComponentSkin"
    ],
    "dataTypes": [
      "HtmlComponent"
    ],
    "styles": {
      "htco1": "wysiwyg.viewer.skins.HtmlComponentSkin"
    },
    "nickname": "html"
  },
  "wysiwyg.viewer.components.ItunesButton": {
    "type": "Component",
    "skins": [
      "skins.viewer.itunesbutton.ItunesButtonSkin"
    ],
    "dataTypes": [
      "ItunesButton"
    ],
    "styles": {
      "ib1": "skins.viewer.itunesbutton.ItunesButtonSkin"
    },
    "nickname": "iTunesButton",
    "propertyTypes": [
      "ItunesButtonProperties"
    ],
    "externalizable": true
  },
  "wysiwyg.viewer.components.LinkBar": {
    "type": "Component",
    "externalizable": true,
    "responsiveSkins": [],
    "skins": [
      "wysiwyg.viewer.skins.LinkBarNoBGSkin"
    ],
    "dataTypes": [
      "ImageList"
    ],
    "styles": {
      "lb1": "wysiwyg.viewer.skins.LinkBarNoBGSkin"
    },
    "nickname": "socialBar",
    "propertyTypes": [
      "LinkBarProperties"
    ]
  },
  "wysiwyg.viewer.components.LinkBarItem": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      "Image"
    ],
    "styles": {},
    "nickname": "linkBarItem"
  },
  "wysiwyg.viewer.components.LoginButton": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.button.LoginButtonSkin"
    ],
    "dataTypes": [
      "LoginButton",
      ""
    ],
    "styles": {
      "lgn0": "wysiwyg.viewer.skins.button.LoginButtonSkin"
    },
    "nickname": "memberLoginButton"
  },
  "wysiwyg.viewer.components.LoginSocialBar": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.LoginSocialBarSkin"
    ],
    "dataTypes": [
      "LoginSocialBar"
    ],
    "styles": {
      "lsb0": "wysiwyg.viewer.skins.LoginSocialBarSkin"
    },
    "nickname": "accountNavBar",
    "propertyTypes": [
      "LoginSocialBarProperties"
    ]
  },
  "wysiwyg.viewer.components.MatrixGallery": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.gallerymatrix.MatrixGalleryDefaultSkin",
      "wysiwyg.viewer.skins.gallerymatrix.TextBottomCustomHeightSkin",
      "wysiwyg.viewer.skins.gallerymatrix.PolaroidCustomHeightSkin",
      "wysiwyg.viewer.skins.gallerymatrix.MatrixGalleryLiftedShadow",
      "wysiwyg.viewer.skins.gallerymatrix.MatrixGallerySloopy",
      "wysiwyg.viewer.skins.gallerymatrix.MatrixGalleryCircleSkin",
      "wysiwyg.viewer.skins.gallerymatrix.MatrixGalleryTextSlideUpSkin",
      "skins.viewer.gallerymatrix.MatrixGalleryIronSkin",
      "skins.viewer.gallerymatrix.MatrixGalleryScotchTapeSkin",
      "wysiwyg.common.components.matrixgallery.viewer.skins.MatrixGalleryTextOnCenterSkin",
      "wysiwyg.common.components.matrixgallery.viewer.skins.MatrixGallerySeparateTextBoxSkin",
      "wysiwyg.viewer.skins.gallerymatrix.MatrixGalleryTransparentSkin"
    ],
    "dataTypes": [
      "ImageList"
    ],
    "styles": {
      "mg1": "wysiwyg.viewer.skins.gallerymatrix.MatrixGalleryDefaultSkin",
      "mg2": "wysiwyg.viewer.skins.gallerymatrix.TextBottomCustomHeightSkin",
      "mg3": "wysiwyg.viewer.skins.gallerymatrix.PolaroidCustomHeightSkin"
    },
    "nickname": "gallery",
    "propertyTypes": [
      "MatrixGalleryProperties"
    ]
  },
  "wysiwyg.viewer.components.MediaRichText": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      "MediaRichText",
      "StyledText"
    ],
    "styles": {},
    "nickname": "text"
  },
  "wysiwyg.viewer.components.PayPalButton": {
    "type": "Component",
    "skins": [
      "wysiwyg.viewer.skins.PayPalButtonSkin"
    ],
    "dataTypes": [
      "PayPalButton"
    ],
    "styles": {
      "ppb0": "wysiwyg.viewer.skins.PayPalButtonSkin"
    },
    "nickname": "paypalButton",
    "propertyTypes": [
      "PayPalButtonProperties"
    ],
    "externalizable": true
  },
  "wysiwyg.viewer.components.PinterestFollow": {
    "type": "Component",
    "skins": [
      "skins.viewer.pinterestfollow.PinterestFollowSkin"
    ],
    "dataTypes": [
      "PinterestFollow"
    ],
    "styles": {
      "pf1": "skins.viewer.pinterestfollow.PinterestFollowSkin"
    },
    "nickname": "pinterestFollow",
    "externalizable": true
  },
  "wysiwyg.viewer.components.SiteButton": {
    "type": "Component",
    "responsiveSkins": [
      "wysiwyg.viewer.skins.button.WrappingButton"
    ],
    "skins": [
      "wysiwyg.viewer.skins.button.BasicButton",
      "wysiwyg.viewer.skins.button.ButtonThreeD",
      "wysiwyg.viewer.skins.button.ButtonLiftedShadow",
      "wysiwyg.viewer.skins.button.ShinyButtonInverted",
      "wysiwyg.viewer.skins.button.ButtonArrow",
      "wysiwyg.viewer.skins.button.ButtonArrowLeft",
      "wysiwyg.viewer.skins.button.ButtonInnerShadow",
      "wysiwyg.viewer.skins.button.ButtonShadowRight",
      "wysiwyg.viewer.skins.button.ButtonShadowLeft",
      "wysiwyg.viewer.skins.button.TextOnlyButtonSkin",
      "wysiwyg.viewer.skins.button.ShinyButtonISkin",
      "wysiwyg.viewer.skins.button.ShinyButtonIISkin",
      "wysiwyg.viewer.skins.button.RibbonButton",
      "wysiwyg.viewer.skins.button.CircleButton",
      "wysiwyg.viewer.skins.button.SloopyButton",
      "wysiwyg.viewer.skins.button.IronButton",
      "wysiwyg.viewer.skins.button.GamingButton",
      "wysiwyg.viewer.skins.button.ScotchTapeButton"
    ],
    "dataTypes": [
      "LinkableButton",
      "SiteButtonData"
    ],
    "styles": {
      "b1": "wysiwyg.viewer.skins.button.BasicButton",
      "b2": "wysiwyg.viewer.skins.button.ButtonThreeD",
      "b3": "wysiwyg.viewer.skins.button.ButtonLiftedShadow",
      "b4": "wysiwyg.viewer.skins.button.ShinyButtonInverted"
    },
    "nickname": "button",
    "propertyTypes": [
      "ButtonProperties"
    ],
    "externalizable": true
  },
  "wysiwyg.viewer.components.SliderGallery": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.galleryslider.SliderGalleryDefaultSkin",
      "wysiwyg.viewer.skins.galleryslider.SliderGalleryCircleSkin",
      "wysiwyg.viewer.skins.galleryslider.SliderGalleryNoArrow",
      "wysiwyg.viewer.skins.galleryslider.SliderGalleryIronSkin",
      "wysiwyg.viewer.skins.galleryslider.SliderGalleryScotchTapeSkin"
    ],
    "dataTypes": [
      "ImageList"
    ],
    "styles": {
      "sg1": "wysiwyg.viewer.skins.galleryslider.SliderGalleryDefaultSkin",
      "sg2": "wysiwyg.viewer.skins.galleryslider.SliderGalleryCircleSkin",
      "sg3": "wysiwyg.viewer.skins.galleryslider.SliderGalleryNoArrow"
    },
    "nickname": "gallery",
    "propertyTypes": [
      "SliderGalleryProperties"
    ]
  },
  "wysiwyg.viewer.components.SlideShowGallery": {
    "type": "Component",
    "skins": [
      "wysiwyg.viewer.skins.gallery.SlideShowTextOverlay",
      "wysiwyg.viewer.skins.gallery.SlideShowTextFloating",
      "wysiwyg.viewer.skins.gallery.SlideShowTextRight",
      "wysiwyg.viewer.skins.gallery.SlideShowPolaroid",
      "wysiwyg.viewer.skins.gallery.SlideShowTextBottom",
      "wysiwyg.viewer.skins.gallery.SlideShowGallerySloopy",
      "wysiwyg.viewer.skins.gallery.SlideShowGalleryLiftedShadowSkin",
      "skins.viewer.gallery.SlideShowIron",
      "skins.viewer.gallery.SlideShowCleanAndSimple2",
      "skins.viewer.gallery.SlideShowScotchTape",
      "skins.viewer.gallery.SlideShowCleanAndSimple"
    ],
    "dataTypes": [
      "ImageList"
    ],
    "styles": {
      "ssg1": "wysiwyg.viewer.skins.gallery.SlideShowTextOverlay",
      "ssg2": "wysiwyg.viewer.skins.gallery.SlideShowTextFloating",
      "ssg3": "wysiwyg.viewer.skins.gallery.SlideShowTextRight"
    },
    "nickname": "gallery",
    "propertyTypes": [
      "SlideShowGalleryProperties"
    ],
    "externalizable": true
  },
  "wysiwyg.viewer.components.SoundCloudWidget": {
    "type": "Component",
    "skins": [
      "wysiwyg.viewer.skins.SoundCloudWidgetSkin"
    ],
    "dataTypes": [
      "SoundCloudWidget"
    ],
    "styles": {
      "scw1": "wysiwyg.viewer.skins.SoundCloudWidgetSkin"
    },
    "nickname": "soundcloud",
    "externalizable": true
  },
  "wysiwyg.viewer.components.TwitterFeed": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.TwitterFeedSkin"
    ],
    "dataTypes": [
      "TwitterFollow"
    ],
    "styles": {
      "twf1": "wysiwyg.viewer.skins.TwitterFeedSkin"
    },
    "nickname": "twitterFeed",
    "propertyTypes": [
      "TwitterFeedProperties"
    ]
  },
  "wysiwyg.viewer.components.VerticalRepeater": {
    "type": "RepeaterContainer",
    "skins": [
      "wysiwyg.viewer.skins.VerticalRepeaterEmptySkin",
      "wysiwyg.viewer.skins.VerticalRepeaterSkin"
    ],
    "dataTypes": [
      "",
      "ImageList"
    ],
    "styles": {
      "vr1": "wysiwyg.viewer.skins.VerticalRepeaterEmptySkin",
      "vr2": "wysiwyg.viewer.skins.VerticalRepeaterSkin",
      "vr3": "wysiwyg.viewer.skins.VerticalRepeaterSkin",
      "vr4": "wysiwyg.viewer.skins.VerticalRepeaterSkin"
    },
    "nickname": "verticalRepeater"
  },
  "wysiwyg.viewer.components.Video": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.VideoSkin",
      "wysiwyg.viewer.skins.video.VideoDefault",
      "wysiwyg.viewer.skins.video.VideoSloppy",
      "wysiwyg.viewer.skins.video.VideoLiftedShadow"
    ],
    "dataTypes": [
      "Video"
    ],
    "styles": {
      "v1": "wysiwyg.viewer.skins.VideoSkin",
      "v2": "wysiwyg.viewer.skins.video.VideoDefault"
    },
    "nickname": "video",
    "propertyTypes": [
      "VideoProperties"
    ]
  },
  "wysiwyg.viewer.components.VKShareButton": {
    "type": "Component",
    "skins": [
      "skins.viewer.vkshare.VKShareSkin"
    ],
    "dataTypes": [
      "VKShareButton"
    ],
    "styles": {
      "vks1": "skins.viewer.vkshare.VKShareSkin"
    },
    "nickname": "vkShare",
    "propertyTypes": [
      "VKShareProperties"
    ],
    "externalizable": true
  },
  "wysiwyg.viewer.components.WPhoto": {
    "type": "Component",
    "externalizable": true,
    "responsiveSkins": [
      "wysiwyg.viewer.skins.photo.NoSkinPhoto"
    ],
    "skins": [
      "wysiwyg.viewer.skins.photo.NoSkinPhoto",
      "wysiwyg.viewer.skins.photo.MouseOverPhoto",
      "wysiwyg.viewer.skins.photo.RoundPhoto",
      "wysiwyg.viewer.skins.photo.LiftedShadowPhoto",
      "wysiwyg.viewer.skins.photo.LiftedTopPhoto",
      "wysiwyg.viewer.skins.photo.PolaroidPhoto",
      "wysiwyg.viewer.skins.photo.CirclePhoto",
      "wysiwyg.viewer.skins.photo.SloppyPhoto",
      "wysiwyg.viewer.skins.photo.DoubleBorderPhoto",
      "wysiwyg.viewer.skins.photo.ScotchDoubleHorizontal",
      "wysiwyg.viewer.skins.photo.ScotchDoubleVertical",
      "wysiwyg.viewer.skins.photo.ScotchTopPhoto",
      "wysiwyg.viewer.skins.photo.IronPhoto",
      "wysiwyg.viewer.skins.photo.GlowLinePhoto",
      "wysiwyg.viewer.skins.photo.NewPolaroidPhoto"
    ],
    "dataTypes": [
      "Image"
    ],
    "styles": {
      "ca1": "wysiwyg.viewer.skins.photo.NoSkinPhoto",
      "wp1": "wysiwyg.viewer.skins.photo.NoSkinPhoto",
      "wp2": "wysiwyg.viewer.skins.photo.MouseOverPhoto",
      "wp3": "wysiwyg.viewer.skins.photo.RoundPhoto",
      "wp4": "wysiwyg.viewer.skins.photo.LiftedShadowPhoto"
    },
    "nickname": "image",
    "propertyTypes": [
      "WPhotoProperties"
    ]
  },
  "wysiwyg.viewer.components.WRichText": {
    "type": "Component",
    "externalizable": true,
    "responsiveSkins": [
      "wysiwyg.viewer.skins.WRichTextNewSkin"
    ],
    "skins": [
      "wysiwyg.viewer.skins.WRichTextSkin",
      "wysiwyg.viewer.skins.WRichTextNewSkin",
      "wysiwyg.viewer.skins.WRichTextThemeSkin"
    ],
    "dataTypes": [
      "RichText",
      "StyledText"
    ],
    "styles": {
      "txtNew": "wysiwyg.viewer.skins.WRichTextNewSkin",
      "txt1": "wysiwyg.viewer.skins.WRichTextSkin",
      "txtTheme": "wysiwyg.viewer.skins.WRichTextThemeSkin"
    },
    "nickname": "text",
    "propertyTypes": [
      "",
      "WRichTextProperties"
    ]
  },
  "wysiwyg.viewer.components.WTwitterFollow": {
    "type": "Component",
    "skins": [
      "mobile.core.skins.TwitterFollowSkin",
      "skins.core.TwitterFollowSkin"
    ],
    "dataTypes": [
      "TwitterFollow"
    ],
    "styles": {
      "tf1": "skins.core.TwitterFollowSkin"
    },
    "nickname": "twitterFollow",
    "propertyTypes": [
      "WTwitterFollowProperties"
    ],
    "externalizable": true
  },
  "wysiwyg.viewer.components.WTwitterTweet": {
    "type": "Component",
    "skins": [
      "skins.core.TwitterTweetSkin"
    ],
    "dataTypes": [
      "TwitterTweet"
    ],
    "styles": {
      "twt1": "skins.core.TwitterTweetSkin"
    },
    "nickname": "twitterTweet",
    "propertyTypes": [
      "WTwitterTweetProperties"
    ],
    "externalizable": true
  },
  "wysiwyg.viewer.components.inputs.ComboBoxInput": {
    "type": "Component",
    "skins": [
      "ComboBoxInputSkin",
      "wysiwyg.viewer.skins.input.ComboBoxInputSkin",
      "wysiwyg.viewer.skins.input.ComboBoxInputSkinNoValidation",
      "wysiwyg.viewer.skins.appinputs.AppsComboBoxInputSkin",
      "wysiwyg.viewer.skins.appinputs.AppsComboBoxInputSkinNoValidation"
    ],
    "dataTypes": [
      "SelectableList",
      "ComboBoxInputData"
    ],
    "styles": {
      "wa_cb1": "wysiwyg.viewer.skins.input.ComboBoxInputSkin",
      "wa_cb2": "wysiwyg.viewer.skins.input.ComboBoxInputSkinNoValidation",
      "wa_cb3": "wysiwyg.viewer.skins.appinputs.AppsComboBoxInputSkin"
    },
    "nickname": "dropdown",
    "propertyTypes": [
      "ComboBoxInputProperties"
    ],
    "externalizable": true
  },
  "wysiwyg.viewer.components.inputs.TextOption": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      "SelectOption"
    ],
    "styles": {},
    "nickname": "textOption"
  },
  "ecommerce.integration.components.MobileTextOption": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      "SelectOption"
    ],
    "styles": {},
    "nickname": "mobileTextOption"
  },
  "wysiwyg.viewer.components.inputs.ColorOption": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      "SelectOption"
    ],
    "styles": {},
    "nickname": "colorOption"
  },
  "ecommerce.integration.components.MobileColorOption": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      "SelectOption"
    ],
    "styles": {},
    "nickname": "mobileColorOption"
  },
  "wysiwyg.viewer.components.mobile.TinyMenu": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.mobile.TinyMenuFullScreenSkin",
      "wysiwyg.viewer.skins.mobile.TinyMenuPullFromLeftSkin",
      "wysiwyg.viewer.skins.mobile.TinyMenuPullFromRightSkin"
    ],
    "dataTypes": [
      "",
      "TinyMenu"
    ],
    "styles": {
      "tm1": "wysiwyg.viewer.skins.mobile.TinyMenuSkin",
      "tm2": "wysiwyg.viewer.skins.mobile.TinyMenuSkin",
      "tmFull1": "wysiwyg.viewer.skins.mobile.TinyMenuFullScreenSkin",
      "tmFull2": "wysiwyg.viewer.skins.mobile.TinyMenuFullScreenSkin"
    },
    "nickname": "mobileMenu",
    "propertyTypes": [
      "",
      "TinyMenuProperties"
    ]
  },
  "wysiwyg.viewer.components.ExpandableMenu": {
    "type": "Component",
    "skins": [
      "wysiwyg.viewer.skins.ExpandableMenuSkin"
    ],
    "dataTypes": [
      "CustomMenuDataRef"
    ],
    "styles": {
      "ExpandableMenu_1": "wysiwyg.viewer.skins.ExpandableMenuSkin"
    },
    "nickname": "expandableMenu",
    "propertyTypes": [
      "ExpandableMenuProperties"
    ],
    "externalizable": true
  },
  "wysiwyg.viewer.components.QuickActionBar": {
    "type": "Container",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.quickActionBar.anchoredSkin",
      "wysiwyg.viewer.skins.quickActionBar.floatingSkin",
      "wysiwyg.viewer.skins.quickActionBar.ovalSkin",
      "wysiwyg.viewer.skins.quickActionBar.rectSkin"
    ],
    "dataTypes": [
      ""
    ],
    "styles": {
      "anchored": "wysiwyg.viewer.skins.quickActionBar.anchoredSkin",
      "floating": "wysiwyg.viewer.skins.quickActionBar.floatingSkin",
      "oval": "wysiwyg.viewer.skins.quickActionBar.ovalSkin",
      "rect": "wysiwyg.viewer.skins.quickActionBar.rectSkin"
    },
    "nickname": "quickActionBar",
    "propertyTypes": [
      "QuickActionBarProperties"
    ]
  },
  "wysiwyg.viewer.components.QuickActionBarItem": {
    "type": "Component",
    "externalizable": true,
    "skins": [],
    "dataTypes": [
      "QuickActionBarItem"
    ],
    "styles": {},
    "nickname": "quickActionBarItem"
  },
  "tpa.viewer.components.Collage": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.TPACollageSkin"
    ],
    "dataTypes": [
      "ImageList"
    ],
    "styles": {
      "tpacol1": "wysiwyg.viewer.skins.TPACollageSkin"
    },
    "nickname": "gallery",
    "propertyTypes": [
      "CollageProperties"
    ]
  },
  "tpa.viewer.components.Freestyle": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.TPAFreestyleSkin"
    ],
    "dataTypes": [
      "ImageList"
    ],
    "styles": {
      "tpafs1": "wysiwyg.viewer.skins.TPAFreestyleSkin"
    },
    "nickname": "gallery",
    "propertyTypes": [
      "FreestyleProperties"
    ]
  },
  "wysiwyg.viewer.components.TouchMediaZoom": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.TouchMediaZoom"
    ],
    "dataTypes": [
      "ImageList"
    ],
    "styles": {
      "tmZoomSlideshow1": "wysiwyg.viewer.skins.TouchMediaZoom"
    },
    "nickname": "touchMediaZoom"
  },
  "wysiwyg.viewer.components.TouchMediaZoomItem": {
    "type": "Component",
    "skins": [
      "wysiwyg.viewer.skins.TouchMediaZoomItem"
    ],
    "dataTypes": [
      "Image"
    ],
    "styles": {
      "touchMediaZoomItem1": "wysiwyg.viewer.skins.TouchMediaZoomItem"
    },
    "nickname": "touchMediaZoomItem"
  },
  "tpa.viewer.components.Honeycomb": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.TPAHoneycombSkin"
    ],
    "dataTypes": [
      "ImageList"
    ],
    "styles": {
      "tpahc1": "wysiwyg.viewer.skins.TPAHoneycombSkin"
    },
    "nickname": "gallery",
    "propertyTypes": [
      "HoneycombProperties"
    ]
  },
  "tpa.viewer.components.Masonry": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.TPAMasonrySkin"
    ],
    "dataTypes": [
      "ImageList"
    ],
    "styles": {
      "tpms1": "wysiwyg.viewer.skins.TPAMasonrySkin"
    },
    "nickname": "gallery",
    "propertyTypes": [
      "MasonryProperties"
    ]
  },
  "wysiwyg.viewer.components.tpapps.TPA3DCarousel": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.TPA3DCarouselSkin"
    ],
    "dataTypes": [
      "ImageList"
    ],
    "styles": {
      "tfc1": "wysiwyg.viewer.skins.TPA3DCarouselSkin"
    },
    "nickname": "gallery",
    "propertyTypes": [
      "SlideShowGalleryProperties"
    ]
  },
  "wysiwyg.viewer.components.tpapps.TPA3DGallery": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.TPA3DGallerySkin"
    ],
    "dataTypes": [
      "ImageList"
    ],
    "styles": {
      "tfg1": "wysiwyg.viewer.skins.TPA3DGallerySkin"
    },
    "nickname": "gallery",
    "propertyTypes": [
      "SlideShowGalleryProperties"
    ]
  },
  "tpa.viewer.components.StripShowcase": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.TPAStripShowcaseSkin"
    ],
    "dataTypes": [
      "ImageList"
    ],
    "styles": {
      "tpasc1": "wysiwyg.viewer.skins.TPAStripShowcaseSkin"
    },
    "nickname": "gallery",
    "propertyTypes": [
      "StripShowcaseProperties"
    ]
  },
  "tpa.viewer.components.StripSlideshow": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.TPAStripSlideshowSkin"
    ],
    "dataTypes": [
      "ImageList"
    ],
    "styles": {
      "tpastr1": "wysiwyg.viewer.skins.TPAStripSlideshowSkin"
    },
    "nickname": "gallery",
    "propertyTypes": [
      "StripSlideshowProperties"
    ]
  },
  "tpa.viewer.components.Thumbnails": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.TPAThumbnailsSkin"
    ],
    "dataTypes": [
      "ImageList"
    ],
    "styles": {
      "thmb1": "wysiwyg.viewer.skins.TPAThumbnailsSkin"
    },
    "nickname": "gallery",
    "propertyTypes": [
      "ThumbnailsProperties"
    ]
  },
  "tpa.viewer.components.Accordion": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.TPAAccordionSkin"
    ],
    "dataTypes": [
      "ImageList"
    ],
    "styles": {
      "tpaacc1": "wysiwyg.viewer.skins.TPAAccordionSkin"
    },
    "nickname": "gallery",
    "propertyTypes": [
      "AccordionProperties"
    ]
  },
  "tpa.viewer.components.Impress": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.TPAImpressSkin"
    ],
    "dataTypes": [
      "ImageList"
    ],
    "styles": {
      "tpaimprs": "wysiwyg.viewer.skins.TPAImpressSkin"
    },
    "nickname": "gallery",
    "propertyTypes": [
      "ImpressProperties"
    ]
  },
  "wysiwyg.common.components.exitmobilemode.viewer.ExitMobileMode": {
    "type": "Component",
    "skins": [
      "wysiwyg.common.components.exitmobilemode.viewer.skins.ExitMobileModeSkin"
    ],
    "dataTypes": [
      "LinkableButton"
    ],
    "styles": {
      "emb1": "wysiwyg.common.components.exitmobilemode.viewer.skins.ExitMobileModeSkin"
    },
    "nickname": "backToDesktopButton",
    "propertyTypes": [
      "ButtonProperties"
    ]
  },
  "wysiwyg.common.components.NumericStepper": {
    "type": "Component",
    "skins": [
      "wysiwyg.common.components.numericstepper.viewer.skins.NumericStepperSimpleSkin"
    ],
    "dataTypes": [
      "NumericStepper"
    ],
    "styles": {
      "NumericStepper_1": "wysiwyg.common.components.numericstepper.viewer.skins.NumericStepperSimpleSkin"
    },
    "nickname": "numericStepper",
    "propertyTypes": [
      "NumericStepperProperties"
    ]
  },
  "wysiwyg.viewer.components.FiveGridLine": {
    "type": "Component",
    "externalizable": true,
    "responsiveSkins": [
      "wysiwyg.viewer.skins.line.SolidLineStudio",
      "wysiwyg.viewer.skins.line.DashedLineStudio",
      "wysiwyg.viewer.skins.line.DottedLineStudio"
    ],
    "skins": [
      "wysiwyg.viewer.skins.line.SolidLine",
      "wysiwyg.viewer.skins.line.FadeLine",
      "wysiwyg.viewer.skins.line.FadeNotchTopLine",
      "wysiwyg.viewer.skins.line.FadeNotchBottomLine",
      "wysiwyg.viewer.skins.line.NotchDashedLine",
      "wysiwyg.viewer.skins.line.DashedLine",
      "wysiwyg.viewer.skins.line.DottedLine",
      "wysiwyg.viewer.skins.line.DoubleLine",
      "wysiwyg.viewer.skins.line.NotchLine",
      "wysiwyg.viewer.skins.line.ShadowTopLine",
      "wysiwyg.viewer.skins.line.ShadowBottomLine",
      "wysiwyg.viewer.skins.line.ArrowRightLine",
      "wysiwyg.viewer.skins.line.ArrowLine",
      "wysiwyg.viewer.skins.line.SloppyLine",
      "wysiwyg.viewer.skins.line.IronLine",
      "wysiwyg.viewer.skins.line.ZigzagLineSkin",
      "wysiwyg.viewer.skins.line.ZigzagLineFlipSkin"
    ],
    "dataTypes": [
      ""
    ],
    "styles": {
      "hl1": "wysiwyg.viewer.skins.line.SolidLine",
      "hl2": "wysiwyg.viewer.skins.line.FadeLine",
      "hl3": "wysiwyg.viewer.skins.line.FadeNotchTopLine",
      "hl4": "wysiwyg.viewer.skins.line.FadeNotchBottomLine"
    },
    "nickname": "line",
    "propertyTypes": [
      "",
      "FiveGridLineProperties"
    ]
  },
  "wysiwyg.viewer.components.PageGroup": {
    "type": "Container",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.PageGroupSkin"
    ],
    "dataTypes": [
      ""
    ],
    "styles": {},
    "nickname": "pageGroup",
    "propertyTypes": [
      "PageGroupProperties"
    ]
  },
  "wysiwyg.viewer.components.PaginatedGridGallery": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.paginatedgrid.PaginatedGridDefaultSkin",
      "wysiwyg.viewer.skins.paginatedgrid.PaginatedGridArrowsOutside",
      "wysiwyg.viewer.skins.paginatedgrid.PaginatedGridOverlay",
      "wysiwyg.viewer.skins.paginatedgrid.PaginatedGridRibbonArrows",
      "wysiwyg.viewer.skins.paginatedgrid.PaginatedGridTextBottom"
    ],
    "dataTypes": [
      "ImageList"
    ],
    "styles": {
      "pagg1": "wysiwyg.viewer.skins.paginatedgrid.PaginatedGridOverlay",
      "pagg2": "wysiwyg.viewer.skins.paginatedgrid.PaginatedGridArrowsOutside",
      "pagg3": "wysiwyg.viewer.skins.paginatedgrid.PaginatedGridRibbonArrows"
    },
    "nickname": "gallery",
    "propertyTypes": [
      "PaginatedGridGalleryProperties"
    ]
  },
  "wysiwyg.viewer.components.WFacebookComment": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "mobile.core.skins.FacebookCommentSkin",
      "skins.core.FacebookCommentSkin"
    ],
    "dataTypes": [
      "",
      "WFacebookComment"
    ],
    "styles": {
      "fbc1": "skins.core.FacebookCommentSkin"
    },
    "nickname": "facebookComments",
    "propertyTypes": [
      "WFacebookCommentProperties"
    ]
  },
  "wysiwyg.common.components.disquscomments.viewer.DisqusComments": {
    "type": "Component",
    "skins": [
      "wysiwyg.common.components.disquscomments.viewer.skins.DisqusCommentsSkin"
    ],
    "dataTypes": [
      "DisqusComments"
    ],
    "styles": {
      "disq2": "wysiwyg.common.components.disquscomments.viewer.skins.DisqusCommentsSkin"
    },
    "nickname": "disqusComments",
    "externalizable": true
  },
  "wysiwyg.viewer.components.WFacebookLike": {
    "type": "Component",
    "skins": [
      "skins.core.FacebookLikeSkin"
    ],
    "dataTypes": [
      "",
      "WFacebookLike"
    ],
    "styles": {
      "fbl1": "skins.core.FacebookLikeSkin"
    },
    "nickname": "facebookLike",
    "propertyTypes": [
      "WFacebookLikeProperties"
    ],
    "externalizable": true
  },
  "wysiwyg.viewer.components.WGooglePlusOne": {
    "type": "Component",
    "skins": [
      "mobile.core.skins.GooglePlusOneSkin",
      "skins.core.GooglePlusOneSkin"
    ],
    "dataTypes": [
      ""
    ],
    "styles": {
      "gp1": "skins.core.GooglePlusOneSkin"
    },
    "nickname": "google1",
    "propertyTypes": [
      "WGooglePlusOneProperties"
    ]
  },
  "wysiwyg.viewer.components.svgshape.SvgShape": {
    "type": "Component",
    "skins": [
      "skins.viewer.svgshape.SvgShapeDefaultSkin"
    ],
    "dataTypes": [
      "SvgShape",
      ""
    ],
    "styles": {
      "assh": "skins.viewer.svgshape.SvgShapeDefaultSkin"
    },
    "nickname": "shape",
    "propertyTypes": [
      "SvgShapeProperties"
    ]
  },
  "wysiwyg.viewer.components.VectorImage": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "skins.viewer.VectorImageSkin"
    ],
    "dataTypes": [
      "VectorImage"
    ],
    "styles": {
      "vi1": "skins.viewer.VectorImageSkin"
    },
    "nickname": "vectorImage",
    "designDataTypes": [
      "VectorImageDesignData"
    ],
    "propertyTypes": [
      "VectorImageProperties"
    ]
  },
  "wysiwyg.viewer.components.svgPrimitive.SvgPrimitive": {
    "type": "Component",
    "skins": [],
    "dataTypes": [],
    "styles": {
      "svgp1": "skins.viewer.svgPrimitive.SvgShapeDefaultSkin"
    },
    "nickname": "svgPrimitive"
  },
  "wysiwyg.viewer.components.SiteRegionContainer": {
    "type": "Container",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.mediaContainer.DefaultMediaContainer"
    ],
    "dataTypes": [
      ""
    ],
    "styles": {
      "sirc1": "wysiwyg.viewer.skins.mediaContainer.DefaultMediaContainer"
    },
    "nickname": "container"
  },
  "mobile.core.components.Container": {
    "type": "Container",
    "externalizable": true,
    "aliases": [
      "core.components.ContainerOBC",
      "core.components.Container"
    ],
    "responsiveSkins": [
      "wysiwyg.viewer.skins.area.DefaultAreaSkin"
    ],
    "skins": [
      "wysiwyg.viewer.skins.area.DefaultAreaSkin",
      "wysiwyg.viewer.skins.area.RectangleArea",
      "wysiwyg.viewer.skins.area.AppleArea",
      "wysiwyg.viewer.skins.area.CircleArea",
      "wysiwyg.viewer.skins.area.BubbleArea",
      "wysiwyg.viewer.skins.area.BubbleLeftArea",
      "wysiwyg.viewer.skins.area.RibbonAreaSkin",
      "wysiwyg.viewer.skins.area.ThreeDeeAreaSkin",
      "wysiwyg.viewer.skins.area.LiftedShadowArea",
      "wysiwyg.viewer.skins.area.LiftedTopAreaSkin",
      "wysiwyg.viewer.skins.area.LiftedBottomAreaSkin",
      "wysiwyg.viewer.skins.area.InnerShadowAreaSkin",
      "wysiwyg.viewer.skins.area.SloopyArea",
      "wysiwyg.viewer.skins.area.BorderDashDefaultAreaSkin",
      "wysiwyg.viewer.skins.area.ForkedRibbonArea",
      "wysiwyg.viewer.skins.area.VerticalRibbonArea",
      "wysiwyg.viewer.skins.area.CenterRibbon",
      "wysiwyg.viewer.skins.area.ArrowRightRibbon",
      "wysiwyg.viewer.skins.area.VerticalArrowArea",
      "wysiwyg.viewer.skins.area.SandClockArea",
      "wysiwyg.viewer.skins.area.DBDefaultAreaSkin",
      "wysiwyg.viewer.skins.area.BubbleAreaLeft",
      "wysiwyg.viewer.skins.area.LeftTriangleArea",
      "wysiwyg.viewer.skins.area.RightTriangleArea",
      "wysiwyg.viewer.skins.area.BubbleAreaRight",
      "wysiwyg.viewer.skins.area.IronBox",
      "wysiwyg.viewer.skins.area.PhotoArea",
      "skins.viewer.area.ScotchTopArea",
      "skins.viewer.area.ScotchDoubleHorizontalArea",
      "skins.viewer.area.ScotchDoubleVerticalArea"
    ],
    "dataTypes": [
      "ContainerData",
      ""
    ],
    "styles": {
      "c1": "wysiwyg.viewer.skins.area.DefaultAreaSkin",
      "c2": "wysiwyg.viewer.skins.area.RectangleArea",
      "c3": "wysiwyg.viewer.skins.area.AppleArea",
      "c4": "wysiwyg.viewer.skins.area.CircleArea"
    },
    "nickname": "box"
  },
  "wixui.SlotsPlaceholder": {
    "type": "Container",
    "externalizable": true,
    "styles": {},
    "slotsDataType": "PlaceholderSlot",
    "dataTypes": [
      "SlotsPlaceholderData",
      ""
    ],
    "nickname": "slotsPlaceholder"
  },
  "wysiwyg.viewer.components.MediaBox": {
    "type": "Container",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.mediaContainer.DefaultMediaContainer",
      "wysiwyg.viewer.skins.mediaContainer.MediaBox"
    ],
    "dataTypes": [
      "MediaBoxData",
      ""
    ],
    "styles": {
      "mc1": "wysiwyg.viewer.skins.mediaContainer.DefaultMediaContainer",
      "mb1": "wysiwyg.viewer.skins.mediaContainer.MediaBox"
    },
    "nickname": "mediaBox",
    "designDataTypes": [
      "MediaContainerDesignData"
    ],
    "propertyTypes": [
      "",
      "MediaBoxProperties"
    ]
  },
  "wysiwyg.viewer.components.HoverBox": {
    "type": "Container",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.mediaContainer.DefaultMediaContainer"
    ],
    "dataTypes": [
      ""
    ],
    "styles": {
      "mc1": "wysiwyg.viewer.skins.mediaContainer.DefaultMediaContainer"
    },
    "nickname": "hoverBox",
    "designDataTypes": [
      "MediaContainerDesignData"
    ],
    "propertyTypes": [
      "HoverBoxProperties"
    ]
  },
  "wysiwyg.viewer.components.PopupContainer": {
    "type": "Container",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.stripContainer.DefaultStripContainer"
    ],
    "dataTypes": [
      "LightboxContainer",
      ""
    ],
    "styles": {
      "strc1": "wysiwyg.viewer.skins.stripContainer.DefaultStripContainer"
    },
    "nickname": "lightbox",
    "designDataTypes": [
      "MediaContainerDesignData"
    ],
    "propertyTypes": [
      "PopupContainerProperties"
    ]
  },
  "wysiwyg.viewer.components.PopupCloseTextButton": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.button.BasicButton",
      "wysiwyg.viewer.skins.button.ButtonThreeD",
      "wysiwyg.viewer.skins.button.ButtonLiftedShadow",
      "wysiwyg.viewer.skins.button.ShinyButtonInverted",
      "wysiwyg.viewer.skins.button.ButtonArrow",
      "wysiwyg.viewer.skins.button.ButtonArrowLeft",
      "wysiwyg.viewer.skins.button.ButtonInnerShadow",
      "wysiwyg.viewer.skins.button.ButtonShadowRight",
      "wysiwyg.viewer.skins.button.ButtonShadowLeft",
      "wysiwyg.viewer.skins.button.TextOnlyButtonSkin",
      "wysiwyg.viewer.skins.button.ShinyButtonISkin",
      "wysiwyg.viewer.skins.button.ShinyButtonIISkin",
      "wysiwyg.viewer.skins.button.RibbonButton",
      "wysiwyg.viewer.skins.button.CircleButton",
      "wysiwyg.viewer.skins.button.SloopyButton",
      "wysiwyg.viewer.skins.button.IronButton",
      "wysiwyg.viewer.skins.button.GamingButton",
      "wysiwyg.viewer.skins.button.ScotchTapeButton"
    ],
    "dataTypes": [
      "LinkableButton"
    ],
    "styles": {
      "b1": "wysiwyg.viewer.skins.button.BasicButton",
      "b2": "wysiwyg.viewer.skins.button.ButtonThreeD",
      "b3": "wysiwyg.viewer.skins.button.ButtonLiftedShadow",
      "b4": "wysiwyg.viewer.skins.button.ShinyButtonInverted"
    },
    "nickname": "button",
    "propertyTypes": [
      "ButtonProperties"
    ]
  },
  "wysiwyg.viewer.components.PopupCloseIconButton": {
    "type": "Component",
    "externalizable": true,
    "skins": [],
    "dataTypes": [
      "SvgShape",
      ""
    ],
    "styles": {
      "assh": "skins.viewer.svgshape.SvgShapeDefaultSkin"
    },
    "nickname": "button",
    "propertyTypes": [
      "SvgShapeProperties"
    ]
  },
  "wysiwyg.viewer.components.Group": {
    "type": "Container",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.components.GroupSkin"
    ],
    "dataTypes": [
      ""
    ],
    "styles": {},
    "nickname": "group"
  },
  "wysiwyg.viewer.components.FormContainer": {
    "type": "Container",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.FormContainerSkin"
    ],
    "dataTypes": [
      ""
    ],
    "styles": {},
    "nickname": "form"
  },
  "wysiwyg.viewer.components.WSiteStructure": {
    "type": "Document",
    "skins": [],
    "dataTypes": [
      ""
    ],
    "styles": {},
    "nickname": "site"
  },
  "wysiwyg.viewer.components.HeaderContainer": {
    "type": "Container",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.screenwidthcontainer.AfterScroll",
      "wysiwyg.viewer.skins.screenwidthcontainer.DefaultScreen",
      "wysiwyg.viewer.skins.screenwidthcontainer.DefaultWithFillLayers",
      "wysiwyg.viewer.skins.screenwidthcontainer.BevelScreen",
      "wysiwyg.viewer.skins.screenwidthcontainer.InnerShadowScreen",
      "wysiwyg.viewer.skins.screenwidthcontainer.ThreeDeeScreen",
      "wysiwyg.viewer.skins.screenwidthcontainer.TransparentScreen",
      "wysiwyg.viewer.skins.screenwidthcontainer.LiftedTopScreen",
      "wysiwyg.viewer.skins.screenwidthcontainer.LiftedBottomScreen",
      "wysiwyg.viewer.skins.screenwidthcontainer.ShadowBottomScreen",
      "wysiwyg.viewer.skins.screenwidthcontainer.IronScreen",
      "wysiwyg.viewer.skins.screenwidthcontainer.DoubleBorderScreen"
    ],
    "dataTypes": [
      ""
    ],
    "styles": {
      "hc1": "wysiwyg.viewer.skins.screenwidthcontainer.DefaultScreen",
      "hc2": "wysiwyg.viewer.skins.screenwidthcontainer.BevelScreen",
      "hc3": "wysiwyg.viewer.skins.screenwidthcontainer.InnerShadowScreen"
    },
    "nickname": "header",
    "designDataTypes": [
      "MediaContainerWithDividers",
      ""
    ]
  },
  "wysiwyg.viewer.components.FooterContainer": {
    "type": "Container",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.screenwidthcontainer.DefaultScreen",
      "wysiwyg.viewer.skins.screenwidthcontainer.DefaultWithFillLayers",
      "wysiwyg.viewer.skins.screenwidthcontainer.BevelScreen",
      "wysiwyg.viewer.skins.screenwidthcontainer.InnerShadowScreen",
      "wysiwyg.viewer.skins.screenwidthcontainer.ThreeDeeScreen",
      "wysiwyg.viewer.skins.screenwidthcontainer.TransparentScreen",
      "wysiwyg.viewer.skins.screenwidthcontainer.LiftedTopScreen",
      "wysiwyg.viewer.skins.screenwidthcontainer.LiftedBottomScreen",
      "wysiwyg.viewer.skins.screenwidthcontainer.ShadowTopScreen",
      "wysiwyg.viewer.skins.screenwidthcontainer.IronScreen",
      "wysiwyg.viewer.skins.screenwidthcontainer.DoubleBorderScreen"
    ],
    "dataTypes": [
      ""
    ],
    "styles": {
      "fc1": "wysiwyg.viewer.skins.screenwidthcontainer.DefaultScreen",
      "fc2": "wysiwyg.viewer.skins.screenwidthcontainer.BevelScreen",
      "fc3": "wysiwyg.viewer.skins.screenwidthcontainer.InnerShadowScreen"
    },
    "nickname": "footer",
    "designDataTypes": [
      "MediaContainerWithDividers",
      ""
    ]
  },
  "wysiwyg.viewer.components.PagesContainer": {
    "type": "Container",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.screenwidthcontainer.TransparentScreen"
    ],
    "dataTypes": [
      ""
    ],
    "styles": {
      "pc1": "wysiwyg.viewer.skins.screenwidthcontainer.TransparentScreen",
      "pc2": "wysiwyg.viewer.skins.screenwidthcontainer.TransparentScreen"
    },
    "nickname": "pagesContainer"
  },
  "wysiwyg.viewer.components.StripContainer": {
    "type": "Container",
    "skins": [
      "wysiwyg.viewer.skins.stripContainer.DefaultStripContainer"
    ],
    "dataTypes": [
      "StripContainer"
    ],
    "styles": {
      "strc1": "wysiwyg.viewer.skins.stripContainer.DefaultStripContainer"
    },
    "nickname": "strip"
  },
  "wysiwyg.viewer.components.StripColumnsContainer": {
    "type": "Container",
    "dataTypes": [
      "StripColumnsContainer",
      ""
    ],
    "skins": [
      "wysiwyg.viewer.skins.stripContainer.DefaultStripContainer",
      "wysiwyg.viewer.skins.stripContainer.DesignedStrip"
    ],
    "styles": {
      "strc1": "wysiwyg.viewer.skins.stripContainer.DefaultStripContainer"
    },
    "requiredChildType": "wysiwyg.viewer.components.Column",
    "nickname": "columnStrip",
    "designDataTypes": [
      "MediaContainerDesignData",
      "MediaContainerWithDividers"
    ],
    "propertyTypes": [
      "StripColumnsContainerProperties"
    ],
    "externalizable": true
  },
  "wysiwyg.viewer.components.ClassicSection": {
    "type": "Container",
    "externalizable": true,
    "dataTypes": [
      "ClassicSection",
      ""
    ],
    "nickname": "section",
    "designDataTypes": [
      "MediaContainerDesignData",
      "MediaContainerWithDividers"
    ],
    "propertyTypes": [
      "ClassicSectionProperties"
    ]
  },
  "wysiwyg.viewer.components.Column": {
    "type": "Container",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.mediaContainer.DefaultMediaContainer"
    ],
    "dataTypes": [
      ""
    ],
    "styles": {
      "mc1": "wysiwyg.viewer.skins.mediaContainer.DefaultMediaContainer"
    },
    "nickname": "column",
    "designDataTypes": [
      "MediaContainerDesignData"
    ],
    "propertyTypes": [
      "ColumnProperties"
    ]
  },
  "wysiwyg.viewer.components.MediaPlayer": {
    "type": "Container",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.mediaPlayerSkin"
    ],
    "dataTypes": [
      ""
    ],
    "designDataTypes": [
      "MediaPlayerDesignData"
    ],
    "styles": {
      "mp1": "wysiwyg.viewer.skins.mediaPlayerSkin"
    },
    "nickname": "videoBox",
    "propertyTypes": [
      "MediaPlayerProperties"
    ]
  },
  "wysiwyg.viewer.components.MediaOverlayControls": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "skins.viewer.mediaOverlayControlsDefaultSkin"
    ],
    "dataTypes": [
      ""
    ],
    "designDataTypes": [
      "MediaControlsDesignData"
    ],
    "styles": {
      "mocntDefault": "skins.viewer.mediaOverlayControlsDefaultSkin"
    },
    "nickname": "videoBoxBigPlay",
    "propertyTypes": [
      "MediaOverlayControlsProperties"
    ]
  },
  "wysiwyg.viewer.components.MediaControls": {
    "type": "Component",
    "skins": [
      "skins.viewer.mediaControlsDarkSkin",
      "skins.viewer.mediaControlsLightSkin",
      "skins.viewer.mediaControlsNoControlsSkin"
    ],
    "dataTypes": [
      ""
    ],
    "designDataTypes": [
      "MediaControlsDesignData"
    ],
    "styles": {
      "mcntDefault": "skins.viewer.mediaControlsNoControlsSkin",
      "mcntLight": "skins.viewer.mediaControlsLightSkin",
      "mcntDark": "skins.viewer.mediaControlsDarkSkin"
    },
    "nickname": "videoBoxMute",
    "propertyTypes": [
      "MediaControlsProperties"
    ]
  },
  "wysiwyg.viewer.components.MediaControlPlay": {
    "type": "Component",
    "skins": [
      "skins.viewer.mediaControlPlayDefaultSkin"
    ],
    "dataTypes": [
      ""
    ],
    "styles": {
      "mcp1": "skins.viewer.mediaControlPlayDefaultSkin"
    },
    "nickname": "mediaControlPlay"
  },
  "wysiwyg.viewer.components.MediaControlVolume": {
    "type": "Component",
    "skins": [
      "skins.viewer.mediaControlVolumeDefaultSkin"
    ],
    "dataTypes": [
      ""
    ],
    "styles": {
      "mcv1": "skins.viewer.mediaControlVolumeDefaultSkin"
    },
    "nickname": "mediaControlVolume"
  },
  "wysiwyg.viewer.components.MediaControlFullscreen": {
    "type": "Component",
    "skins": [
      "skins.viewer.mediaControlFullscreenDefaultSkin"
    ],
    "dataTypes": [
      ""
    ],
    "styles": {
      "mcf1": "skins.viewer.mediaControlFullscreenDefaultSkin"
    },
    "nickname": "mediaControlFullscreen"
  },
  "wysiwyg.viewer.components.MediaControlProgress": {
    "type": "Component",
    "skins": [
      "skins.viewer.mediaControlProgressDefaultSkin"
    ],
    "dataTypes": [
      ""
    ],
    "styles": {
      "mcfpr1": "skins.viewer.mediaControlProgressDefaultSkin"
    },
    "nickname": "mediaControlProgress"
  },
  "wysiwyg.viewer.components.MediaControlTime": {
    "type": "Component",
    "skins": [
      "skins.viewer.mediaControlTimeDefaultSkin"
    ],
    "dataTypes": [
      ""
    ],
    "styles": {
      "mct1": "skins.viewer.mediaControlTimeDefaultSkin"
    },
    "nickname": "mediaControlTime"
  },
  "wysiwyg.viewer.components.MediaControlStoryboard": {
    "type": "Component",
    "skins": [
      "skins.viewer.MediaControlStoryboardDefaultSkin"
    ],
    "dataTypes": [
      ""
    ],
    "styles": {
      "mcsb1": "skins.viewer.mediaControlStoryboardDefaultSkin",
      "mcsb2": "skins.viewer.mediaControlStoryboardMinimalSkin"
    },
    "nickname": "mediaControlStoryboard"
  },
  "wysiwyg.viewer.components.ScreenWidthContainer": {
    "type": "Container",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.screenwidthcontainer.DefaultScreen",
      "wysiwyg.viewer.skins.screenwidthcontainer.BevelScreen",
      "wysiwyg.viewer.skins.screenwidthcontainer.IronScreen",
      "wysiwyg.viewer.skins.screenwidthcontainer.DoubleBorderScreen"
    ],
    "dataTypes": [
      ""
    ],
    "styles": {
      "sc1": "wysiwyg.viewer.skins.screenwidthcontainer.DefaultScreen",
      "sc2": "wysiwyg.viewer.skins.screenwidthcontainer.BevelScreen",
      "sc3": "wysiwyg.viewer.skins.screenwidthcontainer.IronScreen",
      "sc4": "wysiwyg.viewer.skins.screenwidthcontainer.DoubleBorderScreen"
    },
    "nickname": "strip"
  },
  "wysiwyg.viewer.components.VerticalLine": {
    "type": "Component",
    "externalizable": true,
    "responsiveSkins": [
      "wysiwyg.viewer.skins.line.VerticalSolidLine",
      "wysiwyg.viewer.skins.line.VerticalNotchDashedLine",
      "wysiwyg.viewer.skins.line.VerticalDottedLine"
    ],
    "skins": [
      "wysiwyg.viewer.skins.line.VerticalSolidLine",
      "wysiwyg.viewer.skins.line.VerticalFadeNotchLeftLine",
      "wysiwyg.viewer.skins.line.VerticalFadeNotchRightLine",
      "wysiwyg.viewer.skins.line.VerticalNotchDashedLine",
      "wysiwyg.viewer.skins.line.VerticalShadowLeftLine",
      "wysiwyg.viewer.skins.line.VerticalShadowRightLine",
      "wysiwyg.viewer.skins.line.VerticalDoubleLine",
      "wysiwyg.viewer.skins.line.VerticalDashedLine",
      "wysiwyg.viewer.skins.line.VerticalDottedLine",
      "wysiwyg.viewer.skins.line.VerticalNotchLine",
      "wysiwyg.viewer.skins.line.VerticalSloopyLine",
      "wysiwyg.viewer.skins.line.VerticalArrowLineTop",
      "wysiwyg.viewer.skins.line.VerticalArrowLine",
      "wysiwyg.viewer.skins.line.VerticalIronLine"
    ],
    "dataTypes": [
      ""
    ],
    "styles": {
      "vl1": "wyiwyg.viewer.skins.line.VerticalSolidLine",
      "vl2": "wysiwyg.viewer.skins.line.VerticalFadeNotchLeftLine",
      "vl3": "wysiwyg.viewer.skins.line.VerticalFadeNotchRightLine",
      "vl4": "wysiwyg.viewer.skins.line.VerticalNotchDashedLine"
    },
    "nickname": "line"
  },
  "wysiwyg.viewer.components.tpapps.TPAGluedWidget": {
    "type": "Container",
    "aliases": [
      "tpa.viewer.components.tpapps.TPAGluedWidget"
    ],
    "skins": [
      "wysiwyg.viewer.skins.TPAWidgetSkin"
    ],
    "dataTypes": [
      "TPAWidget"
    ],
    "slotsDataType": "DynamicSlots",
    "styles": {
      "tpagw0": "wysiwyg.viewer.skins.TPAWidgetSkin"
    },
    "nickname": "gluedApp",
    "propertyTypes": [
      "TPAGluedProperties"
    ]
  },
  "wysiwyg.viewer.components.tpapps.TPAWidget": {
    "type": "Container",
    "aliases": [
      "tpa.viewer.components.tpapps.TPAWidget"
    ],
    "skins": [
      "wysiwyg.viewer.skins.TPAWidgetSkin"
    ],
    "dataTypes": [
      "TPAWidget"
    ],
    "slotsDataType": "DynamicSlots",
    "styles": {
      "tpaw0": "wysiwyg.viewer.skins.TPAWidgetSkin"
    },
    "nickname": "widget"
  },
  "wysiwyg.viewer.components.tpapps.TPASection": {
    "type": "Container",
    "aliases": [
      "tpa.viewer.components.tpapps.TPASection"
    ],
    "skins": [
      "wysiwyg.viewer.skins.TPASectionSkin"
    ],
    "dataTypes": [
      "TPA"
    ],
    "slotsDataType": "DynamicSlots",
    "styles": {
      "tpas0": "wysiwyg.viewer.skins.TPASectionSkin"
    },
    "nickname": "pageApp"
  },
  "wysiwyg.viewer.components.tpapps.TPAMultiSection": {
    "type": "Container",
    "aliases": [
      "tpa.viewer.components.tpapps.TPAMultiSection"
    ],
    "skins": [
      "wysiwyg.viewer.skins.TPASectionSkin"
    ],
    "dataTypes": [
      "TPAMultiSection"
    ],
    "slotsDataType": "DynamicSlots",
    "styles": {
      "tpas0": "wysiwyg.viewer.skins.TPASectionSkin"
    },
    "nickname": "pageApp"
  },
  "wysiwyg.common.components.backtotopbutton.viewer.BackToTopButton": {
    "type": "Component",
    "skins": [
      "wysiwyg.viewer.skins.backtotopbutton.BackToTopButtonSkin"
    ],
    "dataTypes": [
      ""
    ],
    "styles": {
      "BackToTopButton_1": "wysiwyg.viewer.skins.backtotopbutton.BackToTopButtonSkin"
    },
    "nickname": "backToTop"
  },
  "wysiwyg.viewer.components.BackToTopButton": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "skins.viewer.VectorImageSkin"
    ],
    "dataTypes": [
      "VectorImage"
    ],
    "styles": {
      "vi1": "skins.viewer.VectorImageSkin"
    },
    "nickname": "backToTop",
    "designDataTypes": [
      "VectorImageDesignData"
    ],
    "propertyTypes": [
      "VectorImageProperties"
    ]
  },
  "wysiwyg.viewer.components.SiteBackground": {
    "type": "Component",
    "externalizable": true,
    "skins": [],
    "dataTypes": [
      "BackgroundMedia"
    ],
    "styles": {
      "siteBackground": "wysiwyg.viewer.skins.siteBackgroundSkin"
    },
    "nickname": "siteBackground"
  },
  "wysiwyg.viewer.components.dialogs.EnterPasswordDialog": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      ""
    ],
    "styles": {},
    "nickname": "enterPasswordDialog"
  },
  "wysiwyg.viewer.components.dialogs.NotificationDialog": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      ""
    ],
    "styles": {},
    "nickname": "notificationDialog"
  },
  "wysiwyg.viewer.components.dialogs.siteMemberDialogs.SignUpDialog": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      ""
    ],
    "styles": {},
    "nickname": "signUpDialog"
  },
  "wysiwyg.viewer.components.dialogs.siteMemberDialogs.MemberLoginDialog": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      ""
    ],
    "styles": {},
    "nickname": "memberLoginDialog"
  },
  "wysiwyg.viewer.components.dialogs.siteMemberDialogs.RequestPasswordResetDialog": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      ""
    ],
    "styles": {},
    "nickname": "requestPasswordResetDialog"
  },
  "wysiwyg.viewer.components.dialogs.siteMemberDialogs.ResetPasswordDialog": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      ""
    ],
    "styles": {},
    "nickname": "resetPasswordDialog"
  },
  "ecommerce.viewer.dialogs.EcomCheckoutMessageDialog": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      ""
    ],
    "styles": {},
    "nickname": "ecomCheckoutMessageDialog"
  },
  "core.components.ZoomedImage": {
    "type": "Component",
    "externalizable": true,
    "skins": [],
    "dataTypes": [
      "Image"
    ],
    "styles": {},
    "nickname": "zoomedImage"
  },
  "wysiwyg.components.imageZoom": {
    "type": "Component",
    "externalizable": true,
    "skins": [],
    "dataTypes": [
      "Image"
    ],
    "styles": {},
    "nickname": "imageZoom"
  },
  "wysiwyg.components.ImageZoomDisplayer": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      "Image"
    ],
    "styles": {},
    "nickname": "imageZoomDisplayer"
  },
  "wixapps.integration.components.AppPartZoom": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      "PermaLink"
    ],
    "styles": {},
    "nickname": "appPartZoom"
  },
  "wysiwyg.viewer.components.MediaZoom": {
    "type": "Component",
    "externalizable": true,
    "skins": [],
    "dataTypes": [
      ""
    ],
    "styles": {},
    "nickname": "mediaZoom"
  },
  "wysiwyg.viewer.components.MobileMediaZoom": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      ""
    ],
    "styles": {},
    "nickname": "mobileMediaZoom"
  },
  "wysiwyg.viewer.components.inputs.ErasableTextInput": {
    "type": "Component",
    "skins": [
      "wysiwyg.viewer.skins.appinputs.EcomErasableTextInputSkin"
    ],
    "dataTypes": [
      "TextInput"
    ],
    "styles": {
      "ecom_eti1": "wysiwyg.viewer.skins.appinputs.EcomErasableTextInputSkin"
    },
    "nickname": "textInput",
    "propertyTypes": [
      "TextInputProperties"
    ],
    "externalizable": true
  },
  "wysiwyg.common.components.InfoTip": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      ""
    ],
    "styles": {},
    "nickname": "infoTip"
  },
  "wysiwyg.components.viewer.inputs.InputWithValidation": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      ""
    ],
    "styles": {},
    "nickname": "input"
  },
  "wysiwyg.viewer.components.MessageView": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      ""
    ],
    "styles": {},
    "nickname": "messageView"
  },
  "wixapps.integration.components.Area": {
    "type": "Container",
    "skins": [],
    "dataTypes": [
      ""
    ],
    "styles": {},
    "nickname": "area"
  },
  "wysiwyg.viewer.components.inputs.TextAreaInput": {
    "type": "Component",
    "skins": [
      "TextAreaDefaultSkin",
      "wysiwyg.viewer.skins.input.TextAreaInputSkin",
      "wysiwyg.viewer.skins.appinputs.AppsTextAreaInputSkin",
      "wysiwyg.viewer.skins.appinputs.AppsTextAreaInputSkinNoValidation"
    ],
    "dataTypes": [
      "TextAreaInput"
    ],
    "styles": {},
    "nickname": "textBox",
    "propertyTypes": [
      "TextAreaInputProperties"
    ],
    "externalizable": true
  },
  "wixapps.integration.components.inputs.TextArea": {
    "type": "Component",
    "externalizable": true,
    "skins": [],
    "dataTypes": [
      "TextAreaInput"
    ],
    "styles": {},
    "nickname": "textArea",
    "propertyTypes": [
      "TextAreaInputProperties"
    ]
  },
  "wixapps.integration.components.Toggle": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      ""
    ],
    "styles": {},
    "nickname": "toggle"
  },
  "wysiwyg.viewer.components.MobileActionsMenu": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.mobile.MobileActionsMenuSkin"
    ],
    "dataTypes": [
      ""
    ],
    "styles": {},
    "nickname": "actionMenu"
  },
  "wysiwyg.viewer.components.Table": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      ""
    ],
    "styles": {},
    "nickname": "table"
  },
  "wysiwyg.viewer.components.tpapps.TPAModal": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      ""
    ],
    "styles": {},
    "nickname": "tpaModal"
  },
  "wysiwyg.viewer.components.tpapps.TPAPopup": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      ""
    ],
    "styles": {},
    "nickname": "tpaPopup"
  },
  "wysiwyg.viewer.components.tpapps.TPAPreloaderOverlay": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      ""
    ],
    "styles": {},
    "nickname": "preloaderOverly"
  },
  "wysiwyg.viewer.components.tpapps.TPAUnavailableMessageOverlay": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      ""
    ],
    "styles": {},
    "nickname": "unavailableMessageOverlay"
  },
  "tpa.viewer.classes.TPAWorker": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      ""
    ],
    "styles": {},
    "nickname": "tpaWorker"
  },
  "wysiwyg.viewer.components.tpapps.TPAPlaceholder": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      ""
    ],
    "styles": {},
    "nickname": "tpaPlaceholder"
  },
  "wysiwyg.viewer.components.cloud.CloudGluedWidget": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      ""
    ],
    "styles": {},
    "nickname": "cloudWidget"
  },
  "wysiwyg.viewer.components.cloud.CloudWidget": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      ""
    ],
    "styles": {},
    "nickname": "cloudWidget"
  },
  "wysiwyg.viewer.components.background.bgMedia": {
    "type": "Component",
    "skins": [],
    "dataTypes": [],
    "styles": {
      "bgMedia": "skins.viewer.bgMedia.bgMediaSkin"
    },
    "nickname": "bgMedia"
  },
  "wysiwyg.viewer.components.background.bgImage": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      "Image"
    ],
    "styles": {
      "bgImage": "skins.viewer.bgImage.bgImageSkin"
    },
    "nickname": "bgImage"
  },
  "wysiwyg.viewer.components.background.html5Video": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      "WixVideo"
    ],
    "styles": {
      "bgVideo": "skins.viewer.bgVideo.html5VideoSkin"
    },
    "nickname": "html5Video"
  },
  "wysiwyg.viewer.components.background.webglMedia": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      "WixVideo"
    ],
    "styles": {
      "webgl": "skins.viewer.bgVideo.webglMediaSkin"
    },
    "nickname": "webglMedia"
  },
  "wysiwyg.viewer.components.background.iframeVideo": {
    "type": "Component",
    "skins": [],
    "dataTypes": [
      "WixVideo"
    ],
    "styles": {
      "iframeVideo": "skins.viewer.bgVideo.iframeVideoSkin"
    },
    "nickname": "iframeVideo"
  },
  "wysiwyg.viewer.components.background.bgOverlay": {
    "type": "Component",
    "skins": [],
    "dataTypes": [],
    "styles": {
      "bgOverlay": "skins.viewer.bgOverlay.bgOverlaySkin"
    },
    "nickname": "bgOverlay"
  },
  "wysiwyg.viewer.components.BoxSlideShow": {
    "type": "Container",
    "externalizable": true,
    "skins": [
      "wysiwyg.common.components.boxSlideShow.viewer.skins.thinArrowsLargeSelectedCircleSkin",
      "wysiwyg.common.components.boxSlideShow.viewer.skins.thinArrowsSkin",
      "wysiwyg.common.components.boxSlideShow.viewer.skins.squareButtonsSkin",
      "wysiwyg.common.components.boxSlideShow.viewer.skins.longArrowsLargeSelectedCircleSkin"
    ],
    "dataTypes": [
      "",
      "BoxSlideShow"
    ],
    "styles": {
      "boxSlide1": "wysiwyg.common.components.boxSlideShow.viewer.skins.thinArrowsLargeSelectedCircleSkin",
      "boxSlide2": "wysiwyg.common.components.boxSlideShow.viewer.skins.thinArrowsSkin",
      "boxSlide3": "wysiwyg.common.components.boxSlideShow.viewer.skins.squareButtonsSkin",
      "boxSlide4": "wysiwyg.common.components.boxSlideShow.viewer.skins.longArrowsLargeSelectedCircleSkin"
    },
    "requiredChildType": "wysiwyg.viewer.components.BoxSlideShowSlide",
    "nickname": "slideshow",
    "propertyTypes": [
      "BoxSlideShowProperties"
    ]
  },
  "wysiwyg.viewer.components.StateBox": {
    "type": "Container",
    "externalizable": true,
    "skins": [
      "wysiwyg.common.components.statebox.viewer.skins.StateBoxSkin"
    ],
    "dataTypes": [
      "",
      "StateBox"
    ],
    "styles": {
      "stateBox1": "wysiwyg.common.components.statebox.viewer.skins.StateBoxSkin"
    },
    "requiredChildType": "wysiwyg.viewer.components.StateBoxState",
    "nickname": "statebox",
    "propertyTypes": [
      "StateBoxProperties"
    ]
  },
  "wysiwyg.viewer.components.StateStrip": {
    "type": "Container",
    "skins": [
      "wysiwyg.common.components.statebox.viewer.skins.StateStripSkin"
    ],
    "dataTypes": [
      ""
    ],
    "styles": {
      "stateStrip1": "wysiwyg.common.components.statebox.viewer.skins.StateStripSkin"
    },
    "requiredChildType": "wysiwyg.viewer.components.StateStripState",
    "nickname": "stateStrip",
    "propertyTypes": [
      "StateBoxProperties"
    ]
  },
  "wysiwyg.viewer.components.StateBoxState": {
    "type": "Container",
    "skins": [],
    "dataTypes": [
      "",
      "StateBoxState"
    ],
    "designDataTypes": [
      "MediaContainerDesignData"
    ],
    "styles": {
      "stateBoxState1": "wysiwyg.common.components.boxSlideShowSlide.viewer.skins.boxSlideShowSlideSkin"
    },
    "nickname": "state",
    "propertyTypes": [
      "",
      "BoxSlideShowSlideProperties"
    ]
  },
  "wysiwyg.viewer.components.StateBoxFormState": {
    "type": "Container",
    "skins": [
      "wysiwyg.common.components.statebox.viewer.skins.StateBoxStateFormSkin"
    ],
    "dataTypes": [
      ""
    ],
    "designDataTypes": [
      "MediaContainerDesignData"
    ],
    "styles": {
      "stateBoxFormState1": "wysiwyg.common.components.statebox.viewer.skins.StateBoxStateFormSkin"
    },
    "nickname": "stateboxFormState",
    "propertyTypes": [
      "",
      "BoxSlideShowSlideProperties"
    ]
  },
  "wysiwyg.viewer.components.StateStripState": {
    "type": "Container",
    "skins": [],
    "dataTypes": [
      ""
    ],
    "designDataTypes": [
      "MediaContainerDesignData"
    ],
    "styles": {
      "stateStripState1": "wysiwyg.common.components.stripSlideShowSlide.viewer.skins.stripSlideShowSlideSkin"
    },
    "nickname": "stateStripState",
    "propertyTypes": [
      "",
      "StateBoxStateProperties"
    ]
  },
  "wysiwyg.viewer.components.StripContainerSlideShow": {
    "type": "Container",
    "externalizable": true,
    "skins": [
      "wysiwyg.common.components.stripSlideShow.viewer.skins.thinArrowsLargeSelectedCircleSkin",
      "wysiwyg.common.components.stripSlideShow.viewer.skins.thinArrowsSkin",
      "wysiwyg.common.components.stripSlideShow.viewer.skins.squareButtonsSkin",
      "wysiwyg.common.components.stripSlideShow.viewer.skins.longArrowsLargeSelectedCircleSkin"
    ],
    "dataTypes": [
      "",
      "StripContainerSlideShow"
    ],
    "styles": {
      "stripSlide1": "wysiwyg.common.components.stripSlideShow.viewer.skins.thinArrowsLargeSelectedCircleSkin",
      "stripSlide2": "wysiwyg.common.components.stripSlideShow.viewer.skins.thinArrowsSkin",
      "stripSlide3": "wysiwyg.common.components.stripSlideShow.viewer.skins.squareButtonsSkin",
      "stripSlide4": "wysiwyg.common.components.stripSlideShow.viewer.skins.bottomArrowsLargeSelectedCircleSkin"
    },
    "requiredChildType": "wysiwyg.viewer.components.StripContainerSlideShowSlide",
    "nickname": "fullWidthSlides",
    "propertyTypes": [
      "StripContainerSlideShowProperties"
    ]
  },
  "wysiwyg.viewer.components.BoxSlideShowSlide": {
    "type": "Container",
    "skins": [],
    "dataTypes": [
      "BoxSlideShowSlide"
    ],
    "designDataTypes": [
      "MediaContainerDesignData"
    ],
    "styles": {
      "boxSlideShowSlide1": "wysiwyg.common.components.boxSlideShowSlide.viewer.skins.boxSlideShowSlideSkin"
    },
    "nickname": "slideshowSlide",
    "propertyTypes": [
      "",
      "BoxSlideShowSlideProperties"
    ]
  },
  "wysiwyg.viewer.components.StripContainerSlideShowSlide": {
    "type": "Container",
    "skins": [
      "wysiwyg.common.components.stripSlideShowSlide.viewer.skins.stripSlideShowSlideSkin"
    ],
    "dataTypes": [
      "StripContainerSlideShowSlide"
    ],
    "designDataTypes": [
      "MediaContainerDesignData"
    ],
    "styles": {
      "stripSlideShowSlide1": "wysiwyg.common.components.stripSlideShowSlide.viewer.skins.stripSlideShowSlideSkin"
    },
    "nickname": "slide",
    "propertyTypes": [
      "",
      "StripContainerSlideShowSlideProperties"
    ]
  },
  "wysiwyg.viewer.components.inputs.Checkbox": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.input.CheckboxBasicSkin"
    ],
    "dataTypes": [
      "CheckboxInput"
    ],
    "nickname": "checkbox",
    "styles": {},
    "propertyTypes": [
      "CheckboxProperties"
    ]
  },
  "wysiwyg.viewer.components.inputs.RadioButton": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.common.components.radio.viewer.skins.RadioButtonDefaultSkin"
    ],
    "dataTypes": [
      "RadioButton"
    ],
    "styles": {},
    "nickname": "radioButton",
    "propertyTypes": [
      "RadioButtonProperties"
    ]
  },
  "wysiwyg.viewer.components.inputs.RadioGroup": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "skins.input.RadioGroupDefaultSkin"
    ],
    "dataTypes": [
      "RadioGroup"
    ],
    "styles": {
      "rg1": "skins.input.RadioGroupDefaultSkin"
    },
    "nickname": "radioGroup",
    "propertyTypes": [
      "RadioGroupProperties"
    ]
  },
  "wysiwyg.viewer.components.inputs.CheckboxGroup": {
    "type": "Component",
    "skins": [
      "skins.input.CheckboxGroupDefaultSkin"
    ],
    "dataTypes": [
      "CheckboxGroup"
    ],
    "styles": {
      "cg1": "skins.input.CheckboxGroupDefaultSkin"
    },
    "nickname": "checkboxGroup",
    "propertyTypes": [
      "CheckboxGroupProperties"
    ],
    "externalizable": true
  },
  "wysiwyg.viewer.components.inputs.FileUploader": {
    "type": "Component",
    "skins": [
      "wysiwyg.viewer.skins.FileUploaderDefaultSkin"
    ],
    "dataTypes": [
      "FileUploader"
    ],
    "styles": {
      "fu1": "wysiwyg.viewer.skins.FileUploaderDefaultSkin"
    },
    "nickname": "uploadButton",
    "propertyTypes": [
      "FileUploaderProperties"
    ],
    "externalizable": true
  },
  "wysiwyg.viewer.components.inputs.uploadName": {
    "type": "Component",
    "skins": [
      "wysiwyg.viewer.skins.UploadNameDefaultSkin"
    ],
    "dataTypes": [
      "UploadName"
    ],
    "styles": {
      "un1": "wysiwyg.viewer.skins.UploadNameDefaultSkin"
    },
    "nickname": "uploadName",
    "propertyTypes": [
      "UploadNameProperties"
    ]
  },
  "wysiwyg.viewer.components.inputs.DatePicker": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.input.DatePickerDefaultSkin",
      "wysiwyg.viewer.skins.input.DatePickerTextBetweenNavSkin",
      "wysiwyg.viewer.skins.input.DatePickerTextYearNavSkin"
    ],
    "dataTypes": [
      "DatePicker"
    ],
    "styles": {},
    "nickname": "datePicker",
    "propertyTypes": [
      "DatePickerProperties"
    ]
  },
  "wysiwyg.viewer.components.ImageButtonWithText": {
    "type": "Component",
    "skins": [
      "wysiwyg.viewer.skins.IconLeftImageButtonWithText"
    ],
    "dataTypes": [
      "ImageButtonWithText"
    ],
    "styles": {
      "imgBtnWTxt1": "wysiwyg.viewer.skins.IconLeftImageButtonWithText"
    },
    "nickname": "button"
  },
  "wysiwyg.viewer.components.Grid": {
    "type": "Component",
    "skins": [
      "wixui.skins.Skinless"
    ],
    "dataTypes": [
      "Grid"
    ],
    "styles": {
      "Grid1": "wixui.skins.Skinless"
    },
    "nickname": "table",
    "propertyTypes": [
      "GridProperties"
    ],
    "externalizable": true
  },
  "wysiwyg.viewer.components.Repeater": {
    "type": "RepeaterContainer",
    "skins": [
      "wysiwyg.viewer.skins.area.DefaultAreaSkin"
    ],
    "dataTypes": [
      "Repeater"
    ],
    "styles": {
      "c1": "wysiwyg.viewer.skins.area.DefaultAreaSkin"
    },
    "nickname": "repeater",
    "propertyTypes": [
      "CardsLayoutProperties",
      "VerticalLayoutProperties"
    ]
  },
  "wysiwyg.viewer.components.MediaContainer": {
    "type": "Container",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.mediaContainer.DefaultMediaContainer"
    ],
    "dataTypes": [
      ""
    ],
    "styles": {
      "mc1": "wysiwyg.viewer.skins.mediaContainer.DefaultMediaContainer"
    },
    "nickname": "container",
    "designDataTypes": [
      "MediaContainerDesignData"
    ]
  },
  "wysiwyg.viewer.components.InlinePopup": {
    "type": "Component",
    "skins": [
      "wysiwyg.viewer.skins.inlinePopup.DefaultInlinePopup"
    ],
    "dataTypes": [
      ""
    ],
    "styles": {
      "dip1": "wysiwyg.viewer.skins.inlinePopup.DefaultInlinePopup"
    },
    "nickname": "inlinePopup"
  },
  "wysiwyg.viewer.components.MenuContainer": {
    "type": "Container",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.inlinePopup.DefaultInlinePopup"
    ],
    "dataTypes": [
      ""
    ],
    "styles": {
      "mcdip1": "wysiwyg.viewer.skins.inlinePopup.DefaultInlinePopup"
    },
    "nickname": "menuContainer",
    "designDataTypes": [
      "MediaContainerDesignData",
      ""
    ]
  },
  "wysiwyg.viewer.components.InlinePopupToggle": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin12",
      "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin10",
      "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin11",
      "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin5",
      "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin9",
      "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin1",
      "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin4",
      "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin8",
      "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin6",
      "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin2",
      "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin3",
      "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin7",
      "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin14",
      "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin16",
      "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin15",
      "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin13"
    ],
    "styles": {
      "inlinePopupToggleSkin12": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin12",
      "inlinePopupToggleSkin10": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin10",
      "inlinePopupToggleSkin11": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin11",
      "inlinePopupToggleSkin5": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin5",
      "inlinePopupToggleSkin9": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin9",
      "inlinePopupToggleSkin1": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin1",
      "inlinePopupToggleSkin4": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin4",
      "inlinePopupToggleSkin8": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin8",
      "inlinePopupToggleSkin6": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin6",
      "inlinePopupToggleSkin2": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin2",
      "inlinePopupToggleSkin3": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin3",
      "inlinePopupToggleSkin7": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin7",
      "inlinePopupToggleSkin14": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin14",
      "inlinePopupToggleSkin16": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin16",
      "inlinePopupToggleSkin15": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin15",
      "inlinePopupToggleSkin13": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin13"
    },
    "nickname": "inlinePopupToggle"
  },
  "wysiwyg.viewer.components.MenuToggle": {
    "type": "Component",
    "externalizable": true,
    "skins": [
      "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin12",
      "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin10",
      "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin11",
      "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin5",
      "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin9",
      "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin1",
      "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin4",
      "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin8",
      "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin6",
      "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin2",
      "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin3",
      "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin7",
      "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin14",
      "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin16",
      "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin15",
      "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin13"
    ],
    "styles": {
      "inlinePopupToggleSkin12": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin12",
      "inlinePopupToggleSkin10": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin10",
      "inlinePopupToggleSkin11": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin11",
      "inlinePopupToggleSkin5": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin5",
      "inlinePopupToggleSkin9": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin9",
      "inlinePopupToggleSkin1": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin1",
      "inlinePopupToggleSkin4": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin4",
      "inlinePopupToggleSkin8": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin8",
      "inlinePopupToggleSkin6": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin6",
      "inlinePopupToggleSkin2": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin2",
      "inlinePopupToggleSkin3": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin3",
      "inlinePopupToggleSkin7": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin7",
      "inlinePopupToggleSkin14": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin14",
      "inlinePopupToggleSkin16": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin16",
      "inlinePopupToggleSkin15": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin15",
      "inlinePopupToggleSkin13": "wysiwyg.viewer.skins.inlinePopupToggle.inlinePopupToggleSkin13"
    },
    "nickname": "menuToggle"
  },
  "platform.components.AppController": {
    "type": "Component",
    "skins": [
      "platform.components.skins.controllerSkin",
      "platform.components.skins.controllerIconAndNameSkin"
    ],
    "dataTypes": [
      "AppController"
    ],
    "styles": {
      "controller1": "platform.components.skins.controllerSkin"
    },
    "nickname": "controller"
  },
  "platform.components.AppWidget": {
    "type": "Container",
    "skins": [],
    "dataTypes": [
      "AppController"
    ],
    "styles": {
      "appWidget1": "platform.components.skins.AppWidgetSkin",
      "appWidget2": "platform.components.skins.AppWidgetLoaderSkin"
    },
    "nickname": "appWidget"
  },
  "wysiwyg.viewer.components.LanguageSelector": {
    "type": "Component",
    "skins": [
      "wysiwyg.viewer.skins.LanguageSelectorSkin"
    ],
    "dataTypes": [
      "LanguageSelector",
      ""
    ],
    "styles": {},
    "nickname": "languageSelector",
    "propertyTypes": [
      "LanguageSelectorProperties"
    ],
    "externalizable": true
  },
  "wysiwyg.viewer.components.Popover": {
    "type": "Container",
    "skins": [],
    "dataTypes": [
      ""
    ],
    "styles": {
      "pop1": "wysiwyg.viewer.skins.popover.PopoverSkin"
    },
    "nickname": "popover",
    "propertyTypes": [
      "PopoverProperties"
    ]
  },
  "wysiwyg.viewer.components.RefComponent": {
    "type": "RefComponent",
    "dataTypes": [
      "WidgetRef",
      "InternalRef",
      "InternalBlocksRef"
    ],
    "propertyTypes": [
      "",
      "RefComponentProperties"
    ],
    "styles": {
      "ref1": "skins.core.InlineSkin"
    },
    "nickname": "refComponent"
  },
  "responsive.components.Section": {
    "type": "Container",
    "responsiveSkins": [],
    "dataTypes": [
      "Section",
      ""
    ],
    "skins": [
      "skins.core.InlineSkin",
      "wysiwyg.viewer.skins.area.DefaultAreaSkin"
    ],
    "designDataTypes": [
      "",
      "MediaContainerDesignData",
      "MediaContainerWithDividers"
    ],
    "styles": {
      "sec1": "skins.core.InlineSkin"
    },
    "nickname": "section",
    "externalizable": true
  },
  "responsive.components.HeaderSection": {
    "type": "Container",
    "externalizable": true,
    "responsiveSkins": [],
    "skins": [
      "skins.core.InlineSkin",
      "wysiwyg.viewer.skins.area.DefaultAreaSkin"
    ],
    "designDataTypes": [
      "",
      "MediaContainerDesignData",
      "MediaContainerWithDividers"
    ],
    "styles": {
      "sec1": "skins.core.InlineSkin"
    },
    "nickname": "section"
  },
  "responsive.components.FooterSection": {
    "type": "Container",
    "externalizable": true,
    "responsiveSkins": [],
    "skins": [
      "skins.core.InlineSkin",
      "wysiwyg.viewer.skins.area.DefaultAreaSkin"
    ],
    "designDataTypes": [
      "",
      "MediaContainerDesignData",
      "MediaContainerWithDividers"
    ],
    "styles": {
      "sec1": "skins.core.InlineSkin"
    },
    "nickname": "section"
  },
  "responsive.components.MembersAreaSection": {
    "type": "Container",
    "responsiveSkins": [],
    "skins": [
      "skins.core.InlineSkin"
    ],
    "dataTypes": [
      ""
    ],
    "styles": {
      "sec1": "skins.core.InlineSkin"
    },
    "nickname": "section"
  },
  "wixui.MultiStateBox": {
    "type": "Container",
    "dataTypes": [
      "MultiStateBoxData"
    ],
    "skins": [
      "wysiwyg.viewer.skins.area.DefaultAreaSkin"
    ],
    "styles": {
      "MultiStateBox_1": "wysiwyg.viewer.skins.area.DefaultAreaSkin"
    },
    "nickname": "multiStateBox",
    "externalizable": true
  },
  "mobui.MobuiButton": {
    "dataTypes": [
      "mobui.MobuiButton"
    ],
    "styles": {},
    "nickname": "Button",
    "labelDisplayName": "mobui_compDisplayName_MobuiButton",
    "type": "Component",
    "externalizable": true
  },
  "mobui.MobuiDatePicker": {
    "dataTypes": [
      "mobui.MobuiDatePicker"
    ],
    "styles": {},
    "nickname": "DatePicker",
    "labelDisplayName": "mobui_compDisplayName_MobuiDatePicker",
    "type": "Component",
    "externalizable": true
  },
  "mobui.MobuiImage": {
    "dataTypes": [
      "mobui.MobuiImage"
    ],
    "styles": {},
    "nickname": "Image",
    "labelDisplayName": "mobui_compDisplayName_MobuiImage",
    "type": "Component",
    "externalizable": true
  },
  "mobui.MobuiPicker": {
    "dataTypes": [
      "mobui.MobuiPicker"
    ],
    "propertyType": "mobui.MobuiPickerProperties",
    "styles": {},
    "nickname": "Picker",
    "labelDisplayName": "mobui_compDisplayName_MobuiPicker",
    "type": "Component",
    "externalizable": true
  },
  "mobui.MobuiSwitch": {
    "dataTypes": [
      "mobui.MobuiSwitch"
    ],
    "styles": {},
    "nickname": "Switch",
    "labelDisplayName": "mobui_compDisplayName_MobuiSwitch",
    "type": "Component",
    "externalizable": true
  },
  "mobui.MobuiText": {
    "dataTypes": [
      "mobui.MobuiText"
    ],
    "styles": {},
    "nickname": "Text",
    "labelDisplayName": "mobui_compDisplayName_MobuiText",
    "type": "Component",
    "externalizable": true
  },
  "mobui.MobuiTextInput": {
    "dataTypes": [
      "mobui.MobuiTextInput"
    ],
    "propertyType": "mobui.MobuiTextInputProperties",
    "styles": {},
    "nickname": "Input",
    "labelDisplayName": "mobui_compDisplayName_MobuiTextInput",
    "type": "Component",
    "externalizable": true
  },
  "mobui.MobuiVideoPlayer": {
    "dataTypes": [
      "mobui.MobuiVideoPlayer"
    ],
    "styles": {},
    "nickname": "VideoPlayer",
    "labelDisplayName": "mobui_compDisplayName_MobuiVideoPlayer",
    "type": "Component",
    "externalizable": true
  },
  "mobui.MobuiContainer": {
    "dataTypes": [
      ""
    ],
    "styles": {},
    "nickname": "Container",
    "labelDisplayName": "mobui_compDisplayName_MobuiContainer",
    "type": "Container",
    "externalizable": true
  },
  "mobui.MobuiMultiStateBox": {
    "dataTypes": [
      "mobui.MobuiMultiStateBoxData"
    ],
    "styles": {},
    "nickname": "MobuiMultiStateBox",
    "labelDisplayName": "mobui_compDisplayName_MobuiMultiStateBox",
    "type": "Container",
    "externalizable": true
  },
  "wixui.Logo": {
    "dataTypes": [
      "wixui.Logo"
    ],
    "styles": {},
    "nickname": "Logo",
    "labelDisplayName": "wixui_compDisplayName_Logo",
    "type": "Component",
    "externalizable": true
  },
  "wixui.ShareButtons": {
    "dataTypes": [
      "wixui.ShareButtons"
    ],
    "styles": {
      "ShareButtons1": "wixui.skins.Skinless"
    },
    "nickname": "ShareButtons",
    "labelDisplayName": "wixui_compDisplayName_ShareButtons",
    "isStylableComp": true,
    "type": "Component",
    "externalizable": true
  },
  "wixui.AccordionContainer": {
    "type": "Container",
    "dataTypes": [
      "AccordionContainerData"
    ],
    "propertyType": "AccordionContainerProperties",
    "slotsDataType": "DynamicSlots",
    "styles": {
      "accordionContainer1": "wixui.skins.Skinless"
    },
    "nickname": "accordion",
    "isStylableComp": true,
    "verticalCenterDockDisabled": true,
    "verticalDockDisabled": true,
    "externalizable": true
  },
  "wixui.AccordionItem": {
    "type": "Container",
    "dataTypes": [
      "AccordionItemData"
    ],
    "propertyTypes": [
      "DefaultProperties",
      "AccordionItemProperties"
    ],
    "skins": [
      "wysiwyg.viewer.skins.area.DefaultAreaSkin"
    ],
    "styles": {
      "AccordionItem1": "wixui.skins.Skinless"
    },
    "nickname": "accordionItem",
    "isStylableComp": true,
    "externalizable": true
  },
  "wixui.AddressInput": {
    "skins": [
      "wixui.skins.AddressInput"
    ],
    "dataTypes": [
      "AddressInput"
    ],
    "propertyType": "AddressInputProperties",
    "nickname": "addressInput",
    "styles": {
      "ai1": "wixui.skins.AddressInput"
    },
    "type": "Component",
    "externalizable": true
  },
  "wixui.BoltComponent": {
    "dataTypes": [
      "BoltComponentData"
    ],
    "styles": {
      "boltComponent1": "wixui.skins.Skinless"
    },
    "nickname": "boltComponent",
    "labelDisplayName": "component_label_bolt_component",
    "isStylableComp": true,
    "type": "Component",
    "externalizable": true
  },
  "wixui.Breadcrumbs": {
    "dataTypes": [
      "BreadcrumbsData"
    ],
    "propertyType": "BreadcrumbsProperties",
    "styles": {
      "breadcrumbs1": "wixui.skins.Skinless"
    },
    "nickname": "breadcrumbs",
    "isStylableComp": true,
    "type": "Component",
    "externalizable": true
  },
  "wixui.Captcha": {
    "skins": [
      "wixui.skins.Captcha"
    ],
    "dataTypes": [
      "Captcha"
    ],
    "propertyType": "CaptchaProperties",
    "nickname": "captcha",
    "styles": {
      "captcha1": "wixui.skins.Captcha"
    },
    "type": "Component",
    "externalizable": true
  },
  "wixui.CollapsibleText": {
    "dataTypes": [
      "CollapsibleTextData"
    ],
    "propertyType": "CollapsibleTextProperties",
    "styles": {
      "CollapsibleText1": "wixui.skins.Skinless",
      "CollapsibleTextSkin1": "wixui.skins.CollapsibleText"
    },
    "skins": [
      "wixui.skins.Skinless",
      "wixui.skins.CollapsibleText"
    ],
    "nickname": "CollapsibleText",
    "isStylableComp": true,
    "type": "Component",
    "externalizable": true
  },
  "wixui.CustomElementComponent": {
    "dataTypes": [
      "CustomElement"
    ],
    "styles": {},
    "nickname": "CustomElement",
    "labelDisplayName": "component_label_custom_element",
    "skins": [
      "wixui.skins.CustomElement",
      "wixui.skins.Default"
    ],
    "type": "Component",
    "externalizable": true
  },
  "wixui.DynamicRepeater": {
    "type": "RepeaterContainer",
    "skins": [
      "wysiwyg.viewer.skins.area.DefaultAreaSkin"
    ],
    "dataTypes": [
      "Repeater"
    ],
    "styles": {
      "c1": "wysiwyg.viewer.skins.area.DefaultAreaSkin"
    },
    "nickname": "repeater",
    "propertyTypes": [
      "CardsLayoutProperties",
      "VerticalLayoutProperties"
    ],
    "externalizable": true
  },
  "wixui.ExternalComponent": {
    "dataTypes": [
      "wixui.ExternalComponent"
    ],
    "styles": {},
    "nickname": "ReactComponent",
    "labelDisplayName": "wixui_compDisplayName_ExternalComponent",
    "type": "Component",
    "externalizable": true
  },
  "wixui.FastGallery": {
    "type": "Container",
    "dataTypes": [
      "wixui.FastGallery"
    ],
    "styles": {
      "FastGallery1": "wixui.skins.FastGallery"
    },
    "nickname": "FastGallery",
    "labelDisplayName": "wixui_compDisplayName_FastGallery",
    "externalizable": true
  },
  "wixui.HamburgerCloseButton": {
    "propertyTypes": [
      "HamburgerCloseButtonProperties"
    ],
    "dataTypes": [
      "StylableButton"
    ],
    "styles": {
      "HamburgerCloseButton1": "wixui.skins.Skinless",
      "HamburgerCloseButtonSkin1": "wixui.skins.HamburgerCloseButton"
    },
    "nickname": "hamburgerCloseButton",
    "labelDisplayName": "wixui_compDisplayName_HamburgerCloseButton",
    "isStylableComp": true,
    "skins": [
      "wixui.skins.Skinless",
      "wixui.skins.HamburgerCloseButton"
    ],
    "type": "Component",
    "externalizable": true
  },
  "wixui.HamburgerMenuContainer": {
    "type": "Container",
    "dataTypes": [
      "wixui.HamburgerMenuContainer"
    ],
    "propertyTypes": [
      "HamburgerMenuContainerProperties",
      "DefaultProperties"
    ],
    "styles": {},
    "skins": [
      "wixui.skins.Skinless",
      "wixui.skins.HamburgerMenuContainer"
    ],
    "nickname": "hamburgerMenuContainer",
    "labelDisplayName": "wixui_compDisplayName_HamburgerMenuContainer",
    "isStylableComp": true,
    "externalizable": true
  },
  "wixui.HamburgerMenuContent": {
    "type": "Container",
    "nickname": "hamburgerMenuContent",
    "skins": [
      "wixui.skins.HamburgerMenuContent"
    ],
    "styles": {},
    "externalizable": true
  },
  "wixui.HamburgerMenuRoot": {
    "dataTypes": [
      "wixui.HamburgerMenuRoot"
    ],
    "type": "Container",
    "styles": {},
    "nickname": "hamburgerOpenButton",
    "labelDisplayName": "wixui_compDisplayName_HamburgerMenuRoot",
    "externalizable": true
  },
  "wixui.HamburgerOpenButton": {
    "propertyTypes": [
      "HamburgerOpenButtonProperties"
    ],
    "dataTypes": [
      "StylableButton"
    ],
    "styles": {
      "HamburgerOpenButton1": "wixui.skins.Skinless",
      "HamburgerOpenButtonSkin1": "wixui.skins.HamburgerOpenButton"
    },
    "nickname": "hamburgerOpenButtonHidden",
    "labelDisplayName": "wixui_compDisplayName_HamburgerOpenButton",
    "isStylableComp": true,
    "skins": [
      "wixui.skins.Skinless",
      "wixui.skins.HamburgerOpenButton"
    ],
    "type": "Component",
    "externalizable": true
  },
  "wixui.HamburgerOverlay": {
    "type": "Container",
    "dataTypes": [
      "wixui.HamburgerOverlay"
    ],
    "styles": {},
    "skins": [
      "wixui.skins.Skinless",
      "wixui.skins.HamburgerOverlay"
    ],
    "nickname": "hamburgerOverlay",
    "labelDisplayName": "wixui_compDisplayName_HamburgerOverlay",
    "isStylableComp": true,
    "externalizable": true
  },
  "wixui.ImageX": {
    "skins": [
      "wixui.skins.ImageX"
    ],
    "dataTypes": [
      "ImageX"
    ],
    "nickname": "imageX",
    "labelDisplayName": "component_label_WPhoto",
    "styles": {
      "ImageX_1": "wixui.skins.ImageX"
    },
    "type": "Component",
    "externalizable": true
  },
  "wixui.LineShareButton": {
    "skins": [
      "wixui.skins.LineShareButton"
    ],
    "propertyType": "LineShareButtonProperties",
    "nickname": "lineShareButton",
    "labelDisplayName": "component_label_line_share",
    "styles": {
      "lsb1": "wixui.skins.LineShareButton"
    },
    "type": "Component",
    "externalizable": true
  },
  "wixui.LottieEmbed": {
    "dataTypes": [
      "wixui.LottieEmbed"
    ],
    "styles": {},
    "nickname": "LottieEmbed",
    "labelDisplayName": "LottieFiles_component_label",
    "type": "Component",
    "externalizable": true
  },
  "wixui.MegaMenuContainerItem": {
    "type": "Container",
    "dataTypes": [
      "wixui.MegaMenuContainerItem"
    ],
    "skins": [
      "wysiwyg.viewer.skins.area.DefaultAreaSkin",
      "wixui.skins.Dropdown"
    ],
    "styles": {},
    "nickname": "dropdownContainer",
    "labelDisplayName": "megaMenuContainerItem_definition_label_display_name",
    "externalizable": true
  },
  "wixui.Menu": {
    "type": "Container",
    "labelDisplayName": "menu_definition_label_display_name",
    "dataTypes": [
      "MenuData"
    ],
    "slotsDataType": "DynamicSlots",
    "nickname": "menu",
    "skins": [
      "wixui.skins.Menu"
    ],
    "styles": {},
    "externalizable": true
  },
  "wixui.MenuList": {
    "type": "Container",
    "dataTypes": [
      "wixui.MenuList"
    ],
    "styles": {
      "MenuList1": "wixui.skins.MenuList"
    },
    "nickname": "MenuList",
    "labelDisplayName": "wixui_compDisplayName_MenuList",
    "externalizable": true
  },
  "wixui.MusicPlayer": {
    "skins": [
      "wixui.skins.MusicPlayer"
    ],
    "dataTypes": [
      "MusicPlayerData"
    ],
    "propertyType": "MusicPlayerProperties",
    "nickname": "audioPlayer",
    "styles": {
      "MusicPlayer_1": "wixui.skins.MusicPlayer"
    },
    "type": "Component",
    "externalizable": true
  },
  "wixui.OldBlogDeprecation": {
    "skins": [
      "wysiwyg.viewer.skins.area.DefaultAreaSkin"
    ],
    "nickname": "oldBlogDeprecation",
    "labelDisplayName": "component_label_old_blog_deprecation",
    "styles": {
      "OldBlogDeprecation_1": "wysiwyg.viewer.skins.area.DefaultAreaSkin"
    },
    "type": "Component",
    "externalizable": true
  },
  "wixui.OldHoverBoxDeprecation": {
    "skins": [
      "wysiwyg.viewer.skins.area.DefaultAreaSkin"
    ],
    "nickname": "oldHoverBoxDeprecation",
    "labelDisplayName": "component_label_old_hoverbox_deprecation",
    "styles": {
      "OldHoverBoxDeprecation_1": "wysiwyg.viewer.skins.area.DefaultAreaSkin"
    },
    "type": "Component",
    "externalizable": true
  },
  "wixui.Pagination": {
    "skins": [
      "wixui.skins.Pagination",
      "wixui.skins.ResponsivePagination"
    ],
    "dataTypes": [
      "Pagination"
    ],
    "propertyType": "PaginationProperties",
    "nickname": "pagination",
    "styles": {
      "pag1": "wixui.skins.Pagination"
    },
    "type": "Component",
    "externalizable": true
  },
  "wixui.ProductSpecification": {
    "dataTypes": [
      "wixui.ProductSpecification"
    ],
    "styles": {
      "ProductSpecification1": "wixui.skins.ProductSpecification"
    },
    "skins": [
      "wixui.skins.ProductSpecification"
    ],
    "nickname": "ProductSpecification",
    "labelDisplayName": "wixui_compDisplayName_ProductSpecification",
    "type": "Component",
    "externalizable": true
  },
  "wixui.ProGallery": {
    "dataTypes": [
      "ImageList"
    ],
    "styles": {
      "ProGallery1": "wixui.skins.Skinless"
    },
    "nickname": "ProGallery",
    "propertyType": "ProGalleryProperties",
    "isStylableComp": true,
    "translatedLabelDisplayName": "Pro Gallery",
    "type": "Component",
    "externalizable": true
  },
  "wixui.ProgressBar": {
    "skins": [
      "wixui.skins.ProgressBar"
    ],
    "dataTypes": [
      "ProgressBar"
    ],
    "propertyType": "ProgressBarProperties",
    "nickname": "progressBar",
    "labelDisplayName": "component_label_progressBar",
    "styles": {
      "pb1": "wixui.skins.ProgressBar"
    },
    "type": "Component",
    "externalizable": true
  },
  "wixui.RangeSlider": {
    "dataTypes": [
      "wixui.RangeSlider"
    ],
    "propertyType": "RangeSliderProperties",
    "styles": {},
    "nickname": "RangeSlider",
    "translatedLabelDisplayName": "RangeSlider",
    "isStylableComp": true,
    "type": "Component",
    "externalizable": true
  },
  "wixui.RatingsDisplay": {
    "skins": [
      "wixui.skins.Rating"
    ],
    "dataTypes": [
      "RatingsDisplay"
    ],
    "propertyType": "RatingsDisplayProperties",
    "nickname": "ratingsDisplay",
    "styles": {
      "rd1": "wixui.skins.Rating"
    },
    "type": "Component",
    "externalizable": true
  },
  "wixui.RatingsInput": {
    "skins": [
      "wixui.skins.Rating"
    ],
    "dataTypes": [
      "RatingsInput"
    ],
    "propertyType": "RatingsInputProperties",
    "nickname": "ratingsInput",
    "styles": {
      "ri1": "wixui.skins.Rating"
    },
    "type": "Component",
    "externalizable": true
  },
  "wixui.RichContentViewer": {
    "dataTypes": [
      "wixui.RichContentViewer"
    ],
    "styles": {
      "RichContentViewer_1": "wixui.skins.RichContentViewer"
    },
    "skins": [
      "wixui.skins.RichContentViewer"
    ],
    "nickname": "RichContentViewer",
    "labelDisplayName": "wixui_compDisplayName_RichContentViewer",
    "type": "Component",
    "externalizable": true
  },
  "wixui.RichTextBox": {
    "skins": [
      "wixui.skins.RichTextBox"
    ],
    "dataTypes": [
      "RichTextBox"
    ],
    "propertyType": "RichTextBoxProperties",
    "nickname": "richTextBox",
    "styles": {
      "richtextbox1": "wixui.skins.RichTextBox"
    },
    "type": "Component",
    "externalizable": true
  },
  "wixui.Rive": {
    "styles": {
      "Rive1": "wixui.skins.Rive"
    },
    "type": "Component",
    "nickname": "Rive",
    "dataTypes": [
      "wixui.Rive"
    ],
    "externalizable": true
  },
  "wixui.SearchBox": {
    "skins": [
      "wixui.skins.SearchBox"
    ],
    "dataTypes": [
      "SearchBox"
    ],
    "propertyType": "SearchBoxProperties",
    "nickname": "searchBox",
    "styles": {
      "SearchBox_1": "wixui.skins.SearchBox"
    },
    "type": "Component",
    "externalizable": true
  },
  "wixui.SearchButton": {
    "propertyTypes": [
      "SearchButtonProperties"
    ],
    "dataTypes": [
      "StylableButton"
    ],
    "styles": {
      "SearchButton1": "wixui.skins.SearchButton"
    },
    "skins": [
      "wixui.skins.SearchButton"
    ],
    "nickname": "searchButton",
    "labelDisplayName": "component_label_stylable_button",
    "isStylableComp": true,
    "type": "Component",
    "externalizable": true
  },
  "wixui.SelectableContainer": {
    "type": "Container",
    "nickname": "SelectableContainer",
    "dataTypes": [
      "wixui.SelectableContainer"
    ],
    "styles": {
      "SelectableContainer1": "wixui.skins.Skinless",
      "SelectableContainer2": "wixui.skins.SelectableContainer"
    },
    "skins": [
      "wixui.skins.Skinless",
      "wixui.skins.SelectableContainer"
    ],
    "labelDisplayName": "component_label_SelectableContainer",
    "isStylableComp": true,
    "externalizable": true
  },
  "wixui.SelectableContainerInput": {
    "dataTypes": [
      "wixui.SelectableContainerInput"
    ],
    "styles": {
      "SelectableContainerInput1": "wixui.skins.Skinless",
      "SelectableContainerInputSkin1": "wixui.skins.SelectableContainerInput"
    },
    "skins": [
      "wixui.skins.Skinless",
      "wixui.skins.SelectableContainerInput"
    ],
    "nickname": "SelectableContainerInput",
    "labelDisplayName": "wixui_compDisplayName_SelectableContainerInput",
    "isStylableComp": true,
    "type": "Component",
    "externalizable": true
  },
  "wixui.SelectionTagsList": {
    "skins": [
      "wixui.skins.SelectionTagsList"
    ],
    "dataTypes": [
      "SelectionTagsList"
    ],
    "propertyType": "SelectionTagsListProperties",
    "nickname": "selectionTags",
    "labelDisplayName": "component_label_selection_tags",
    "styles": {
      "SelectionTagsList_1": "wixui.skins.SelectionTagsList"
    },
    "type": "Component",
    "externalizable": true
  },
  "wixui.SignatureInput": {
    "skins": [
      "wixui.skins.SignatureInput",
      "wixui.skins.TypeOrDrawSignatureInput"
    ],
    "dataTypes": [
      "SignatureInput"
    ],
    "propertyType": "SignatureInputProperties",
    "nickname": "signatureInput",
    "styles": {
      "SignatureInput_1": "wixui.skins.SignatureInput"
    },
    "type": "Component",
    "externalizable": true
  },
  "wixui.SingleTab": {
    "type": "Container",
    "dataTypes": [
      "wixui.SingleTab"
    ],
    "propertyTypes": [
      "DefaultProperties",
      "SingleTabProperties"
    ],
    "nickname": "singleTab",
    "styles": {},
    "externalizable": true
  },
  "wixui.Slider": {
    "skins": [
      "wixui.skins.Slider"
    ],
    "dataTypes": [
      "Slider"
    ],
    "propertyType": "SliderProperties",
    "nickname": "slider",
    "styles": {
      "slider1": "wixui.skins.Slider"
    },
    "type": "Component",
    "externalizable": true
  },
  "wixui.Slideshow": {
    "type": "Container",
    "propertyType": "SlideshowProperties",
    "dataTypes": [
      "",
      "wixui.Slideshow"
    ],
    "skins": [
      "wysiwyg.viewer.skins.area.DefaultAreaSkin"
    ],
    "styles": {},
    "nickname": "slideshow",
    "isStylableComp": false,
    "externalizable": true
  },
  "wixui.SlideshowButton": {
    "propertyTypes": [
      "SlideshowButtonProperties"
    ],
    "dataTypes": [
      "StylableButton"
    ],
    "styles": {
      "SlideshowButton1": "wixui.skins.Skinless"
    },
    "skins": [
      "wixui.skins.Skinless",
      "wixui.skins.SlideshowButton"
    ],
    "nickname": "slideshowButton",
    "labelDisplayName": "component_label_stylable_button",
    "isStylableComp": true,
    "type": "Component",
    "externalizable": true
  },
  "wixui.SlideshowItem": {
    "type": "Container",
    "externalizable": true,
    "aliases": [
      "core.components.ContainerOBC",
      "core.components.Container"
    ],
    "responsiveSkins": [
      "wysiwyg.viewer.skins.area.DefaultAreaSkin"
    ],
    "skins": [
      "wysiwyg.viewer.skins.area.DefaultAreaSkin"
    ],
    "dataTypes": [
      "ContainerData"
    ],
    "styles": {
      "c1": "wysiwyg.viewer.skins.area.DefaultAreaSkin"
    },
    "nickname": "slideshowItem"
  },
  "wixui.SocialAuth": {
    "skins": [
      "wixui.skins.Skinless"
    ],
    "dataTypes": [
      "SocialAuth"
    ],
    "propertyType": "SocialAuthProperties",
    "nickname": "socialAuth",
    "styles": {
      "SocialAuth_1": "wixui.skins.Skinless"
    },
    "isStylableComp": true,
    "labelDisplayName": "component_label_social_auth",
    "type": "Component",
    "externalizable": true
  },
  "wixui.StretchedContainer": {
    "styles": {},
    "type": "Container",
    "nickname": "StretchedContainer",
    "dataTypes": [
      ""
    ],
    "labelDisplayName": "wixui_compDisplayName_StretchedContainer",
    "externalizable": true
  },
  "wixui.StylableButton": {
    "propertyTypes": [
      "StylableButtonProperties",
      ""
    ],
    "dataTypes": [
      "StylableButton"
    ],
    "styles": {
      "stButton1": "wixui.skins.Skinless",
      "stButton2": "wixui.skins.Skinless",
      "stButton3": "wixui.skins.Skinless",
      "stButton4": "wixui.skins.Skinless",
      "stButton5": "wixui.skins.StylableButton",
      "stButton6": "wixui.skins.StylableButton",
      "stButton7": "wixui.skins.StylableButton",
      "stButton8": "wixui.skins.StylableButton"
    },
    "skins": [
      "wixui.skins.Skinless",
      "wixui.skins.StylableButton",
      "wixui.skins.Button"
    ],
    "nickname": "button",
    "labelDisplayName": "component_label_stylable_button",
    "isStylableComp": true,
    "type": "Component",
    "externalizable": true
  },
  "wixui.StylableHorizontalMenu": {
    "type": "Container",
    "labelDisplayName": "component_label_stylable_horizontal_menu",
    "dataTypes": [
      "CustomMenuDataRef"
    ],
    "slotsDataType": "DynamicSlots",
    "propertyType": "StylableHorizontalMenuProperties",
    "nickname": "horizontalMenu",
    "isStylableComp": true,
    "styles": {
      "stMenu1": "wixui.skins.Skinless",
      "stMenu2": "wixui.skins.Skinless",
      "stMenu3": "wixui.skins.Skinless"
    },
    "externalizable": true
  },
  "wixui.Submenu": {
    "type": "Component",
    "dataTypes": [
      "Submenu"
    ],
    "styles": {},
    "nickname": "dropdownmenu",
    "isStylableComp": false,
    "externalizable": true
  },
  "wixui.SvgImage": {
    "type": "Component",
    "dataTypes": [
      "SvgImage"
    ],
    "skins": [
      "wixui.skins.SvgImage"
    ],
    "responsiveSkins": [
      "wixui.skins.SvgImage"
    ],
    "styles": {},
    "nickname": "svgImage",
    "isStylableComp": false,
    "externalizable": true
  },
  "wixui.Tabs": {
    "type": "Container",
    "dataTypes": [
      "wixui.Tabs"
    ],
    "propertyType": "TabsProperties",
    "styles": {
      "Tabs1": "wysiwyg.viewer.skins.area.DefaultAreaSkin"
    },
    "nickname": "tabs",
    "isStylableComp": true,
    "labelDisplayName": "tabs_component_label",
    "externalizable": true
  },
  "wixui.TestComp": {
    "styles": {
      "TestComp1": "wixui.skins.Skinless"
    },
    "nickname": "TestComp",
    "isStylableComp": true,
    "type": "Component",
    "externalizable": true
  },
  "wixui.TextEffects3d": {
    "type": "Component",
    "dataTypes": [
      "TextEffectsSharedData"
    ],
    "styles": {},
    "responsiveSkins": [
      "wixui.skins.TextEffects3d"
    ],
    "nickname": "textEffects",
    "externalizable": true
  },
  "wixui.TextEffectsBauhaus": {
    "type": "Component",
    "dataTypes": [
      "TextEffectsSharedData"
    ],
    "styles": {},
    "responsiveSkins": [
      "wixui.skins.TextEffectsBauhaus"
    ],
    "nickname": "textEffects",
    "externalizable": true
  },
  "wixui.TextEffectsGlass": {
    "type": "Component",
    "dataTypes": [
      "TextEffectsSharedData"
    ],
    "styles": {},
    "responsiveSkins": [
      "wixui.skins.TextEffectsGlass"
    ],
    "nickname": "textEffects",
    "externalizable": true
  },
  "wixui.TextEffectsGlitch": {
    "type": "Component",
    "dataTypes": [
      "TextEffectsSharedData"
    ],
    "styles": {},
    "responsiveSkins": [
      "wixui.skins.TextEffectsGlitch"
    ],
    "nickname": "textEffects",
    "externalizable": true
  },
  "wixui.TextEffectsLetterPress": {
    "type": "Component",
    "dataTypes": [
      "TextEffectsSharedData"
    ],
    "styles": {},
    "responsiveSkins": [
      "wixui.skins.TextEffectsLetterPress"
    ],
    "nickname": "textEffects",
    "externalizable": true
  },
  "wixui.TextEffectsMatrix": {
    "type": "Component",
    "dataTypes": [
      "TextEffectsSharedData"
    ],
    "styles": {},
    "responsiveSkins": [
      "wixui.skins.TextEffectsMatrix"
    ],
    "nickname": "textEffects",
    "externalizable": true
  },
  "wixui.TextEffectsNeonSign": {
    "type": "Component",
    "dataTypes": [
      "TextEffectsSharedData"
    ],
    "styles": {},
    "responsiveSkins": [
      "wixui.skins.TextEffectsNeonSign"
    ],
    "nickname": "textEffects",
    "externalizable": true
  },
  "wixui.TextEffectsNoisy": {
    "type": "Component",
    "dataTypes": [
      "TextEffectsSharedData"
    ],
    "styles": {},
    "responsiveSkins": [
      "wixui.skins.TextEffectsNoisy"
    ],
    "nickname": "textEffects",
    "externalizable": true
  },
  "wixui.TextEffectsOutlineOut": {
    "type": "Component",
    "dataTypes": [
      "TextEffectsSharedData"
    ],
    "styles": {},
    "responsiveSkins": [
      "wixui.skins.TextEffectsOutlineOut"
    ],
    "nickname": "textEffects",
    "externalizable": true
  },
  "wixui.TextEffectsRetro": {
    "type": "Component",
    "dataTypes": [
      "TextEffectsSharedData"
    ],
    "styles": {},
    "responsiveSkins": [
      "wixui.skins.TextEffectsRetro"
    ],
    "nickname": "textEffects",
    "externalizable": true
  },
  "wixui.TextEffectsShared": {
    "type": "Component",
    "dataTypes": [
      "TextEffectsSharedData"
    ],
    "styles": {},
    "responsiveSkins": [
      "wixui.skins.TextEffectsShared"
    ],
    "nickname": "textEffects",
    "externalizable": true
  },
  "wixui.TextEffectsShook": {
    "type": "Component",
    "dataTypes": [
      "TextEffectsSharedData"
    ],
    "styles": {},
    "responsiveSkins": [
      "wixui.skins.TextEffectsShook"
    ],
    "nickname": "textEffects",
    "externalizable": true
  },
  "wixui.TextEffectsSticker": {
    "type": "Component",
    "dataTypes": [
      "TextEffectsSharedData"
    ],
    "styles": {},
    "responsiveSkins": [
      "wixui.skins.TextEffectsSticker"
    ],
    "nickname": "textEffects",
    "externalizable": true
  },
  "wixui.TextEffectsStriped": {
    "type": "Component",
    "dataTypes": [
      "TextEffectsSharedData"
    ],
    "styles": {},
    "responsiveSkins": [
      "wixui.skins.TextEffectsStriped"
    ],
    "nickname": "textEffects",
    "externalizable": true
  },
  "wixui.TextMarquee": {
    "type": "Component",
    "dataTypes": [
      "TextMarqueeData"
    ],
    "skins": [
      "wixui.skins.TextMarquee"
    ],
    "responsiveSkins": [
      "wixui.skins.TextMarquee"
    ],
    "styles": {},
    "nickname": "textMarquee",
    "isStylableComp": false,
    "externalizable": true
  },
  "wixui.TextMask": {
    "dataTypes": [
      "TextFxData"
    ],
    "designDataTypes": [
      "TextFxMask"
    ],
    "styles": {
      "TextMask1": "wixui.skins.Skinless"
    },
    "nickname": "textMask",
    "isStylableComp": false,
    "type": "Component",
    "externalizable": true
  },
  "wixui.TextOnPath": {
    "type": "Component",
    "dataTypes": [
      "TextOnPathData"
    ],
    "skins": [
      "wixui.skins.TextOnPath"
    ],
    "responsiveSkins": [
      "wixui.skins.TextOnPath"
    ],
    "styles": {},
    "nickname": "textOnPath",
    "isStylableComp": false,
    "allowConnectToDB": true,
    "externalizable": true
  },
  "wixui.TextParticles": {
    "type": "Component",
    "dataTypes": [
      "TextParticlesData"
    ],
    "styles": {},
    "responsiveSkins": [
      "wixui.skins.TextParticles"
    ],
    "nickname": "textParticles",
    "labelDisplayName": "wixui_compDisplayName_TextParticles",
    "externalizable": true
  },
  "wixui.TimePicker": {
    "skins": [
      "wixui.skins.TimePicker"
    ],
    "dataTypes": [
      "TimePickerData"
    ],
    "propertyType": "TimePickerProperties",
    "nickname": "timePicker",
    "styles": {
      "tp1": "wixui.skins.TimePicker"
    },
    "type": "Component",
    "externalizable": true
  },
  "wixui.ToggleSwitch": {
    "skins": [
      "wixui.skins.ToggleSwitch"
    ],
    "dataTypes": [
      "ToggleSwitch"
    ],
    "propertyType": "ToggleSwitchProperties",
    "nickname": "switch",
    "styles": {
      "ts1": "wixui.skins.ToggleSwitch"
    },
    "type": "Component",
    "externalizable": true
  },
  "wixui.UnsupportedComponent": {
    "dataTypes": [
      "UnsupportedComponentData"
    ],
    "styles": {
      "UnsupportedComponent1": "wixui.skins.Skinless"
    },
    "nickname": "UnsupportedComponent",
    "isStylableComp": false,
    "type": "Component",
    "externalizable": true
  },
  "wixui.VideoPlayer": {
    "skins": [
      "wixui.skins.VideoPlayer"
    ],
    "dataTypes": [
      "VideoPlayer"
    ],
    "propertyType": "VideoPlayerProperties",
    "nickname": "videoPlayer",
    "styles": {
      "vp1": "wixui.skins.VideoPlayer"
    },
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.ControlTypes": {
    "dataTypes": [
      "dsgnsys.ControlTypes"
    ],
    "styles": {},
    "nickname": "ControlTypes",
    "labelDisplayName": "dsgnsys_compDisplayName_ControlTypes",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.WutRadioButton": {
    "dataTypes": [
      "dsgnsys.WutRadioButton"
    ],
    "styles": {},
    "nickname": "WutRadioButton",
    "labelDisplayName": "dsgnsys_compDisplayName_WutRadioButton",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.DashboardButton": {
    "dataTypes": [
      "dsgnsys.DashboardButton"
    ],
    "skins": [
      "wixui.skins.Skinless"
    ],
    "styles": {
      "DashboardButton1": "wixui.skins.Skinless"
    },
    "nickname": "DashboardButton",
    "labelDisplayName": "dsgnsys_compDisplayName_DashboardButton",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.DashboardHeading": {
    "dataTypes": [
      "dsgnsys.DashboardHeading"
    ],
    "skins": [
      "wixui.skins.Skinless"
    ],
    "styles": {
      "DashboardHeading1": "wixui.skins.Skinless"
    },
    "nickname": "DashboardHeading",
    "labelDisplayName": "dsgnsys_compDisplayName_DashboardHeading",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.DashboardIconButton": {
    "dataTypes": [
      "dsgnsys.DashboardIconButton"
    ],
    "skins": [
      "wixui.skins.Skinless"
    ],
    "styles": {
      "DashboardIconButton1": "wixui.skins.Skinless"
    },
    "nickname": "DashboardIconButton",
    "labelDisplayName": "dsgnsys_compDisplayName_DashboardIconButton",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.DashboardInfoIcon": {
    "dataTypes": [
      "dsgnsys.DashboardInfoIcon"
    ],
    "skins": [
      "wixui.skins.Skinless"
    ],
    "styles": {
      "DashboardInfoIcon1": "wixui.skins.Skinless"
    },
    "nickname": "DashboardInfoIcon",
    "labelDisplayName": "dsgnsys_compDisplayName_DashboardInfoIcon",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.DashboardInput": {
    "dataTypes": [
      "dsgnsys.DashboardInput"
    ],
    "skins": [
      "wixui.skins.Skinless"
    ],
    "styles": {
      "DashboardInput1": "wixui.skins.Skinless"
    },
    "nickname": "DashboardInput",
    "labelDisplayName": "dsgnsys_compDisplayName_DashboardInput",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.DashboardNumberInput": {
    "dataTypes": [
      "dsgnsys.DashboardNumberInput"
    ],
    "skins": [
      "wixui.skins.Skinless"
    ],
    "styles": {
      "DashboardNumberInput1": "wixui.skins.Skinless"
    },
    "nickname": "DashboardNumberInput",
    "labelDisplayName": "dsgnsys_compDisplayName_DashboardNumberInput",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.DashboardText": {
    "dataTypes": [
      "dsgnsys.DashboardText"
    ],
    "skins": [
      "wixui.skins.Skinless"
    ],
    "styles": {
      "DashboardText1": "wixui.skins.Skinless"
    },
    "nickname": "DashboardText",
    "labelDisplayName": "dsgnsys_compDisplayName_DashboardText",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.DashboardTextButton": {
    "dataTypes": [
      "dsgnsys.DashboardTextButton"
    ],
    "skins": [
      "wixui.skins.Skinless"
    ],
    "styles": {
      "DashboardTextButton1": "wixui.skins.Skinless"
    },
    "nickname": "DashboardTextButton",
    "labelDisplayName": "dsgnsys_compDisplayName_DashboardTextButton",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.DashboardToggleSwitch": {
    "dataTypes": [
      "dsgnsys.DashboardToggleSwitch"
    ],
    "skins": [
      "wixui.skins.Skinless"
    ],
    "styles": {
      "DashboardToggleSwitch1": "wixui.skins.Skinless"
    },
    "nickname": "DashboardToggleSwitch",
    "labelDisplayName": "dsgnsys_compDisplayName_DashboardToggleSwitch",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.SettingsPanelContainer": {
    "dataTypes": [
      "dsgnsys.SettingsPanelContainer"
    ],
    "styles": {},
    "nickname": "SettingsPanelContainer",
    "translatedLabelDisplayName": "SettingsPanelContainer",
    "type": "Container",
    "externalizable": true
  },
  "dsgnsys.WbuAccordion": {
    "dataTypes": [
      "dsgnsys.WbuAccordion"
    ],
    "styles": {},
    "nickname": "PanelAccordion",
    "labelDisplayName": "dsgnsys_compDisplayName_WbuAccordion",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.WbuBackButton": {
    "dataTypes": [
      "dsgnsys.WbuBackButton"
    ],
    "styles": {},
    "nickname": "PanelBackButton",
    "labelDisplayName": "dsgnsys_compDisplayName_WbuBackButton",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.WbuButton": {
    "dataTypes": [
      "dsgnsys.WbuButton"
    ],
    "styles": {},
    "nickname": "PanelButton",
    "labelDisplayName": "dsgnsys_compDisplayName_WbuButton",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.WbuCheckboxGroup": {
    "dataTypes": [
      "dsgnsys.WbuCheckboxGroup"
    ],
    "styles": {},
    "nickname": "PanelCheckboxGroup",
    "labelDisplayName": "dsgnsys_compDisplayName_WbuCheckboxGroup",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.WbuColorPicker": {
    "dataTypes": [
      "dsgnsys.WbuColorPicker"
    ],
    "styles": {},
    "nickname": "PanelColorPicker",
    "labelDisplayName": "dsgnsys_compDisplayName_WbuColorPicker",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.WbuColorSelector": {
    "dataTypes": [
      "dsgnsys.WbuColorSelector"
    ],
    "styles": {},
    "nickname": "PanelColorPicker",
    "labelDisplayName": "dsgnsys_compDisplayName_WbuColorSelector",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.WbuColumnControllerControl": {
    "dataTypes": [
      "dsgnsys.WbuColumnControllerControl"
    ],
    "styles": {},
    "nickname": "panelColumnControl",
    "labelDisplayName": "dsgnsys_compDisplayName_WbuColumnControllerControl",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.WbuDatePicker": {
    "dataTypes": [
      "dsgnsys.WbuDatePicker"
    ],
    "styles": {},
    "nickname": "PanelDatePicker",
    "labelDisplayName": "dsgnsys_compDisplayName_WbuDatePicker",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.WbuDrillDown": {
    "dataTypes": [
      "dsgnsys.WbuDrillDown"
    ],
    "styles": {},
    "nickname": "PanelDrillDown",
    "labelDisplayName": "dsgnsys_compDisplayName_WbuDrillDown",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.WbuDropdown": {
    "dataTypes": [
      "dsgnsys.WbuDropdown"
    ],
    "styles": {},
    "nickname": "PanelDropdown",
    "labelDisplayName": "dsgnsys_compDisplayName_WbuDropdown",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.WbuEmptyState": {
    "dataTypes": [
      "dsgnsys.WbuEmptyState"
    ],
    "styles": {},
    "nickname": "PanelEmptyState",
    "labelDisplayName": "dsgnsys_compDisplayName_WbuEmptyState",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.WbuFontAndColorPicker": {
    "dataTypes": [
      "dsgnsys.WbuFontAndColorPicker"
    ],
    "styles": {},
    "nickname": "PanelFontAndColorPicker",
    "labelDisplayName": "dsgnsys_compDisplayName_WbuFontAndColorPicker",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.WbuHorizontalTabs": {
    "dataTypes": [
      "dsgnsys.WbuHorizontalTabs"
    ],
    "styles": {},
    "nickname": "PanelHorizontalTabs",
    "labelDisplayName": "dsgnsys_compDisplayName_WbuHorizontalTabs",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.WbuLeftTextButton": {
    "dataTypes": [
      "dsgnsys.WbuLeftTextButton"
    ],
    "styles": {},
    "nickname": "PanelLeftTextButton",
    "labelDisplayName": "dsgnsys_compDisplayName_WbuLeftTextButton",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.WbuMultilineTextInput": {
    "dataTypes": [
      "dsgnsys.WbuMultilineTextInput"
    ],
    "styles": {},
    "nickname": "PanelMultilineTextInput",
    "labelDisplayName": "dsgnsys_compDisplayName_WbuMultilineTextInput",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.WbuNotificationBanner": {
    "dataTypes": [
      "dsgnsys.WbuNotificationBanner"
    ],
    "styles": {},
    "nickname": "PanelNotificationBanner",
    "labelDisplayName": "dsgnsys_compDisplayName_WbuNotificationBanner",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.WbuNumericInput": {
    "dataTypes": [
      "dsgnsys.WbuNumericInput"
    ],
    "styles": {},
    "nickname": "PanelNumericInput",
    "labelDisplayName": "dsgnsys_compDisplayName_WbuNumericInput",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.WbuRadioButtonGroup": {
    "dataTypes": [
      "dsgnsys.WbuRadioButtonGroup"
    ],
    "styles": {},
    "nickname": "PanelRadioButtonGroup",
    "labelDisplayName": "dsgnsys_compDisplayName_WbuRadioButtonGroup",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.WbuRichText": {
    "dataTypes": [
      "dsgnsys.WbuRichText"
    ],
    "styles": {},
    "nickname": "PanelRichText",
    "labelDisplayName": "dsgnsys_compDisplayName_WbuRichText",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.WbuSectionDivider": {
    "dataTypes": [
      "dsgnsys.WbuSectionDivider"
    ],
    "styles": {},
    "nickname": "PanelSectionDivider",
    "labelDisplayName": "dsgnsys_compDisplayName_WbuSectionDivider",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.WbuSlider": {
    "dataTypes": [
      "dsgnsys.WbuSlider"
    ],
    "styles": {},
    "nickname": "PanelSlider",
    "labelDisplayName": "dsgnsys_compDisplayName_WbuSlider",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.WbuTextInput": {
    "dataTypes": [
      "dsgnsys.WbuTextInput"
    ],
    "styles": {},
    "nickname": "PanelTextInput",
    "labelDisplayName": "dsgnsys_compDisplayName_WbuTextInput",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.WbuThumbnails": {
    "dataTypes": [
      "dsgnsys.WbuThumbnails"
    ],
    "styles": {},
    "nickname": "PanelThumbnails",
    "labelDisplayName": "dsgnsys_compDisplayName_WbuThumbnails",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.WbuToggleSwitch": {
    "dataTypes": [
      "dsgnsys.WbuToggleSwitch"
    ],
    "styles": {},
    "nickname": "PanelToggleSwitch",
    "labelDisplayName": "dsgnsys_compDisplayName_WbuToggleSwitch",
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.WutAvatar": {
    "dataTypes": [
      "dsgnsys.WutAvatar"
    ],
    "styles": {},
    "nickname": "Avatar",
    "labelDisplayName": "dsgnsys_compDisplayName_WutAvatar",
    "isStylableComp": true,
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.WutAvatarGroup": {
    "dataTypes": [
      "dsgnsys.WutAvatarGroup"
    ],
    "styles": {},
    "nickname": "avatarGroup",
    "labelDisplayName": "dsgnsys_WutAvatarGroup_component_label",
    "isStylableComp": true,
    "type": "Component",
    "externalizable": true
  },
  "dsgnsys.WutBadge": {
    "dataTypes": [
      "dsgnsys.WutBadge"
    ],
    "styles": {
      "WutBadge1": "wixui.skins.Skinless",
      "WutBadgeSkin1": "wixui.skins.WutBadge"
    },
    "nickname": "Badge",
    "skins": [
      "wixui.skins.Skinless",
      "wixui.skins.WutBadge"
    ],
    "labelDisplayName": "dsgnsys_compDisplayName_WutBadge",
    "isStylableComp": true,
    "type": "Component",
    "externalizable": true
  }
}
